import { emptyApi as api } from '../emptyApi';
export const addTagTypes = [
  'Account',
  'Account/Account',
  'Account/Address',
  'Account/ApiKeys',
  'Account/ApiLogs',
  'Account/Attribute',
  'Account/Category',
  'Account/Configuration',
  'Account/ContactMessages',
  'Account/ContactPerson',
  'Account/Contracts',
  'Account/DataObject',
  'Account/LoginMigration',
  'Account/Logins',
  'Account/Logo',
  'Account/Payments',
  'Account/PrintAdvert',
  'Account/Products',
  'Account/Publication',
  'Attribute',
  'Autocomplete',
  'Category',
  'Configuration',
  'DataObject',
  'Favorite',
  'File',
  'Geo',
  'PrintTitle',
  'SearchAlerts',
  'Seo',
  'Statistics',
  'XmlFtpImport',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getV1AccountById: build.query<GetV1AccountByIdResponse, GetV1AccountByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account'],
      }),
      postV1AccountAccount: build.mutation<PostV1AccountAccountResponse, PostV1AccountAccountParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Account`,
          method: 'POST',
          body: queryArg.accountAccountCreateAccountRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Account'],
      }),
      getV1AccountAccount: build.query<GetV1AccountAccountResponse, GetV1AccountAccountParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Account`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/Account'],
      }),
      getV1AccountAccountById: build.query<GetV1AccountAccountByIdResponse, GetV1AccountAccountByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Account/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/Account'],
      }),
      putV1AccountAccountById: build.mutation<PutV1AccountAccountByIdResponse, PutV1AccountAccountByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Account/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.accountAccountUpdateAccountRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Account'],
      }),
      getV1AccountAccountLoginInfo: build.query<
        GetV1AccountAccountLoginInfoResponse,
        GetV1AccountAccountLoginInfoParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Account/LoginInfo`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/Account'],
      }),
      getV1AccountAccountLoginSettings: build.query<
        GetV1AccountAccountLoginSettingsResponse,
        GetV1AccountAccountLoginSettingsParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Account/LoginSettings`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/Account'],
      }),
      putV1AccountAccountLoginSettings: build.mutation<
        PutV1AccountAccountLoginSettingsResponse,
        PutV1AccountAccountLoginSettingsParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Account/LoginSettings`,
          method: 'PUT',
          body: queryArg.accountAccountUpdateLoginSettingsRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Account'],
      }),
      postV1AccountAddress: build.mutation<PostV1AccountAddressResponse, PostV1AccountAddressParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Address`,
          method: 'POST',
          body: queryArg.accountAddressesCreateAddressRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Address'],
      }),
      getV1AccountAddress: build.query<GetV1AccountAddressResponse, GetV1AccountAddressParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Address`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            types: queryArg.types,
          },
        }),
        providesTags: ['Account/Address'],
      }),
      deleteV1AccountAddressById: build.mutation<DeleteV1AccountAddressByIdResponse, DeleteV1AccountAddressByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Address/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Address'],
      }),
      putV1AccountAddressById: build.mutation<PutV1AccountAddressByIdResponse, PutV1AccountAddressByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Address/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.accountAddressesUpdateAddressRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Address'],
      }),
      postV1AccountApiKeys: build.mutation<PostV1AccountApiKeysResponse, PostV1AccountApiKeysParams>({
        query: (queryArg) => ({
          url: `/v1/Account/ApiKeys`,
          method: 'POST',
          body: queryArg.accountApiKeysCreateApiKeyRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ApiKeys'],
      }),
      getV1AccountApiKeys: build.query<GetV1AccountApiKeysResponse, GetV1AccountApiKeysParams>({
        query: (queryArg) => ({
          url: `/v1/Account/ApiKeys`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            includeRevoked: queryArg.includeRevoked,
          },
        }),
        providesTags: ['Account/ApiKeys'],
      }),
      putV1AccountApiKeysByUidRevoke: build.mutation<
        PutV1AccountApiKeysByUidRevokeResponse,
        PutV1AccountApiKeysByUidRevokeParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ApiKeys/${queryArg.uid}/Revoke`,
          method: 'PUT',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ApiKeys'],
      }),
      getV1AccountApiLogsImportExecutionsById: build.query<
        GetV1AccountApiLogsImportExecutionsByIdResponse,
        GetV1AccountApiLogsImportExecutionsByIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ApiLogs/ImportExecutions/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/ApiLogs'],
      }),
      getV1AccountApiLogsImportExecutions: build.query<
        GetV1AccountApiLogsImportExecutionsResponse,
        GetV1AccountApiLogsImportExecutionsParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ApiLogs/ImportExecutions`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            filter: queryArg.filter,
            pageIndex: queryArg.pageIndex,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['Account/ApiLogs'],
      }),
      getV1AccountAttribute: build.query<GetV1AccountAttributeResponse, GetV1AccountAttributeParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Attribute`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            categoryId: queryArg.categoryId,
            onlyEditable: queryArg.onlyEditable,
          },
        }),
        providesTags: ['Account/Attribute'],
      }),
      getV1AccountCategory: build.query<GetV1AccountCategoryResponse, GetV1AccountCategoryParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Category`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            parentId: queryArg.parentId,
            recursive: queryArg.recursive,
          },
        }),
        providesTags: ['Account/Category'],
      }),
      getV1AccountCategoryById: build.query<GetV1AccountCategoryByIdResponse, GetV1AccountCategoryByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Category/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/Category'],
      }),
      getV1AccountConfigurationDataObjectTypes: build.query<
        GetV1AccountConfigurationDataObjectTypesResponse,
        GetV1AccountConfigurationDataObjectTypesParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Configuration/DataObjectTypes`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/Configuration'],
      }),
      getV1AccountConfigurationProcess: build.query<
        GetV1AccountConfigurationProcessResponse,
        GetV1AccountConfigurationProcessParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Configuration/Process`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            categoryId: queryArg.categoryId,
            dataObjectType: queryArg.dataObjectType,
          },
        }),
        providesTags: ['Account/Configuration'],
      }),
      getV1AccountContactMessagesAttachmentsByFileId: build.query<
        GetV1AccountContactMessagesAttachmentsByFileIdResponse,
        GetV1AccountContactMessagesAttachmentsByFileIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactMessages/Attachments/${queryArg.fileId}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/ContactMessages'],
      }),
      getV1AccountContactMessagesById: build.query<
        GetV1AccountContactMessagesByIdResponse,
        GetV1AccountContactMessagesByIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactMessages/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            filter: queryArg.filter,
            pageIndex: queryArg.pageIndex,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['Account/ContactMessages'],
      }),
      getV1AccountContactMessagesCounts: build.query<
        GetV1AccountContactMessagesCountsResponse,
        GetV1AccountContactMessagesCountsParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactMessages/Counts`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/ContactMessages'],
      }),
      getV1AccountContactMessages: build.query<GetV1AccountContactMessagesResponse, GetV1AccountContactMessagesParams>({
        query: (queryArg) => ({
          url: `/v1/Account/ContactMessages`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            dataObjectId: queryArg.dataObjectId,
            participant: queryArg.participant,
            unreadOnly: queryArg.unreadOnly,
            filter: queryArg.filter,
            pageIndex: queryArg.pageIndex,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['Account/ContactMessages'],
      }),
      putV1AccountContactMessagesRead: build.mutation<
        PutV1AccountContactMessagesReadResponse,
        PutV1AccountContactMessagesReadParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactMessages/Read`,
          method: 'PUT',
          body: queryArg.accountContactMessagesMarkReadRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ContactMessages'],
      }),
      putV1AccountContactMessagesByIdUnread: build.mutation<
        PutV1AccountContactMessagesByIdUnreadResponse,
        PutV1AccountContactMessagesByIdUnreadParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactMessages/${queryArg.id}/Unread`,
          method: 'PUT',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ContactMessages'],
      }),
      postV1AccountContactMessagesByIdReply: build.mutation<
        PostV1AccountContactMessagesByIdReplyResponse,
        PostV1AccountContactMessagesByIdReplyParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactMessages/${queryArg.id}/Reply`,
          method: 'POST',
          body: queryArg.accountContactMessagesReplyRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ContactMessages'],
      }),
      postV1AccountContactPerson: build.mutation<PostV1AccountContactPersonResponse, PostV1AccountContactPersonParams>({
        query: (queryArg) => ({
          url: `/v1/Account/ContactPerson`,
          method: 'POST',
          body: queryArg.accountContactPersonsCreateContactPersonRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ContactPerson'],
      }),
      getV1AccountContactPerson: build.query<GetV1AccountContactPersonResponse, GetV1AccountContactPersonParams>({
        query: (queryArg) => ({
          url: `/v1/Account/ContactPerson`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            request: queryArg.request,
          },
        }),
        providesTags: ['Account/ContactPerson'],
      }),
      deleteV1AccountContactPersonById: build.mutation<
        DeleteV1AccountContactPersonByIdResponse,
        DeleteV1AccountContactPersonByIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactPerson/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ContactPerson'],
      }),
      putV1AccountContactPersonById: build.mutation<
        PutV1AccountContactPersonByIdResponse,
        PutV1AccountContactPersonByIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/ContactPerson/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.accountContactPersonsUpdateContactPersonRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/ContactPerson'],
      }),
      postV1AccountContractsCreate: build.mutation<
        PostV1AccountContractsCreateResponse,
        PostV1AccountContractsCreateParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Contracts/Create`,
          method: 'POST',
          body: queryArg.accountContractsCreateContractRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Contracts'],
      }),
      getV1AccountContracts: build.query<GetV1AccountContractsResponse, GetV1AccountContractsParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Contracts`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            includeExpired: queryArg.includeExpired,
          },
        }),
        providesTags: ['Account/Contracts'],
      }),
      postV1AccountContractsUpgrade: build.mutation<
        PostV1AccountContractsUpgradeResponse,
        PostV1AccountContractsUpgradeParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Contracts/Upgrade`,
          method: 'POST',
          body: queryArg.accountContractsUpgradeContractRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Contracts'],
      }),
      putV1AccountDataObjectByIdActivate: build.mutation<
        PutV1AccountDataObjectByIdActivateResponse,
        PutV1AccountDataObjectByIdActivateParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/${queryArg.id}/Activate`,
          method: 'PUT',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/DataObject'],
      }),
      postV1AccountDataObject: build.mutation<PostV1AccountDataObjectResponse, PostV1AccountDataObjectParams>({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/DataObject'],
      }),
      getV1AccountDataObject: build.query<GetV1AccountDataObjectResponse, GetV1AccountDataObjectParams>({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            categoryId: queryArg.categoryId,
            platform: queryArg.platform,
            status: queryArg.status,
            topListed: queryArg.topListed,
            filter: queryArg.filter,
            pageIndex: queryArg.pageIndex,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['Account/DataObject'],
      }),
      putV1AccountDataObjectByIdDeactivate: build.mutation<
        PutV1AccountDataObjectByIdDeactivateResponse,
        PutV1AccountDataObjectByIdDeactivateParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/${queryArg.id}/Deactivate`,
          method: 'PUT',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/DataObject'],
      }),
      deleteV1AccountDataObjectById: build.mutation<
        DeleteV1AccountDataObjectByIdResponse,
        DeleteV1AccountDataObjectByIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/DataObject'],
      }),
      getV1AccountDataObjectById: build.query<GetV1AccountDataObjectByIdResponse, GetV1AccountDataObjectByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/DataObject'],
      }),
      putV1AccountDataObjectById: build.mutation<PutV1AccountDataObjectByIdResponse, PutV1AccountDataObjectByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.body,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/DataObject'],
      }),
      postV1AccountDataObjectByIdDuplicate: build.mutation<
        PostV1AccountDataObjectByIdDuplicateResponse,
        PostV1AccountDataObjectByIdDuplicateParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/${queryArg.id}/Duplicate`,
          method: 'POST',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/DataObject'],
      }),
      getV1AccountDataObjectCounts: build.query<
        GetV1AccountDataObjectCountsResponse,
        GetV1AccountDataObjectCountsParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/Counts`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/DataObject'],
      }),
      putV1AccountDataObjectByIdTopListing: build.mutation<
        PutV1AccountDataObjectByIdTopListingResponse,
        PutV1AccountDataObjectByIdTopListingParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/DataObject/${queryArg.id}/TopListing`,
          method: 'PUT',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            active: queryArg.active,
          },
        }),
        invalidatesTags: ['Account/DataObject'],
      }),
      postV1AccountLoginMigrationValidate: build.mutation<
        PostV1AccountLoginMigrationValidateResponse,
        PostV1AccountLoginMigrationValidateParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/LoginMigration/Validate`,
          method: 'POST',
          body: queryArg.accountLoginMigrationValidateLoginRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/LoginMigration'],
      }),
      putV1AccountLoginsAcceptInvitation: build.mutation<
        PutV1AccountLoginsAcceptInvitationResponse,
        PutV1AccountLoginsAcceptInvitationParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Logins/AcceptInvitation`,
          method: 'PUT',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            accountId: queryArg.accountId,
          },
        }),
        invalidatesTags: ['Account/Logins'],
      }),
      postV1AccountLogins: build.mutation<PostV1AccountLoginsResponse, PostV1AccountLoginsParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Logins`,
          method: 'POST',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            email: queryArg.email,
            role: queryArg.role,
          },
        }),
        invalidatesTags: ['Account/Logins'],
      }),
      getV1AccountLogins: build.query<GetV1AccountLoginsResponse, GetV1AccountLoginsParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Logins`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            filter: queryArg.filter,
            pageIndex: queryArg.pageIndex,
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['Account/Logins'],
      }),
      getV1AccountLoginsInvitations: build.query<
        GetV1AccountLoginsInvitationsResponse,
        GetV1AccountLoginsInvitationsParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Logins/Invitations`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            token: queryArg.token,
          },
        }),
        providesTags: ['Account/Logins'],
      }),
      putV1AccountLoginsRejectInvitation: build.mutation<
        PutV1AccountLoginsRejectInvitationResponse,
        PutV1AccountLoginsRejectInvitationParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Logins/RejectInvitation`,
          method: 'PUT',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            accountId: queryArg.accountId,
          },
        }),
        invalidatesTags: ['Account/Logins'],
      }),
      deleteV1AccountLoginsById: build.mutation<DeleteV1AccountLoginsByIdResponse, DeleteV1AccountLoginsByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Logins/${queryArg.id}`,
          method: 'DELETE',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Logins'],
      }),
      putV1AccountLoginsSetRole: build.mutation<PutV1AccountLoginsSetRoleResponse, PutV1AccountLoginsSetRoleParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Logins/SetRole`,
          method: 'PUT',
          body: queryArg.accountLoginsSetLoginRoleRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Logins'],
      }),
      deleteV1AccountLogo: build.mutation<DeleteV1AccountLogoResponse, DeleteV1AccountLogoParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Logo`,
          method: 'DELETE',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Logo'],
      }),
      postV1AccountLogo: build.mutation<PostV1AccountLogoResponse, PostV1AccountLogoParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Logo`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Logo'],
      }),
      getV1AccountLogoByAccountId: build.query<GetV1AccountLogoByAccountIdResponse, GetV1AccountLogoByAccountIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Logo/${queryArg.accountId}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Account/Logo'],
      }),
      postV1AccountPaymentsCreate: build.mutation<
        PostV1AccountPaymentsCreateResponse,
        PostV1AccountPaymentsCreateParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Payments/Create`,
          method: 'POST',
          body: queryArg.accountPaymentsCreatePaymentRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Payments'],
      }),
      getV1AccountPaymentsContract: build.query<
        GetV1AccountPaymentsContractResponse,
        GetV1AccountPaymentsContractParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Payments/Contract`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            contractId: queryArg.contractId,
            token: queryArg.token,
          },
        }),
        providesTags: ['Account/Payments'],
      }),
      getV1AccountPaymentsOrder: build.query<GetV1AccountPaymentsOrderResponse, GetV1AccountPaymentsOrderParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Payments/Order`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            id: queryArg.id,
            token: queryArg.token,
          },
        }),
        providesTags: ['Account/Payments'],
      }),
      getV1AccountPaymentsStatus: build.query<GetV1AccountPaymentsStatusResponse, GetV1AccountPaymentsStatusParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Payments/Status`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            orderId: queryArg.orderId,
            token: queryArg.token,
          },
        }),
        providesTags: ['Account/Payments'],
      }),
      postV1AccountPaymentsPrintOrder: build.mutation<
        PostV1AccountPaymentsPrintOrderResponse,
        PostV1AccountPaymentsPrintOrderParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Payments/PrintOrder`,
          method: 'POST',
          body: queryArg.accountPaymentsCreatePrintOrderRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Payments'],
      }),
      postV1AccountPaymentsCallbackByProviderNameTransaction: build.mutation<
        PostV1AccountPaymentsCallbackByProviderNameTransactionResponse,
        PostV1AccountPaymentsCallbackByProviderNameTransactionParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Payments/Callback/${queryArg.providerName}/Transaction`,
          method: 'POST',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            'X-Api-Key': queryArg['X-Api-Key'],
            apiKey: queryArg.apiKey,
          },
        }),
        invalidatesTags: ['Account/Payments'],
      }),
      getV1AccountPaymentsToken: build.query<GetV1AccountPaymentsTokenResponse, GetV1AccountPaymentsTokenParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Payments/Token`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            contractId: queryArg.contractId,
            dataObjectId: queryArg.dataObjectId,
            orderId: queryArg.orderId,
          },
        }),
        providesTags: ['Account/Payments'],
      }),
      postV1AccountPrintAdvertAcceptQuote: build.mutation<
        PostV1AccountPrintAdvertAcceptQuoteResponse,
        PostV1AccountPrintAdvertAcceptQuoteParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/PrintAdvert/AcceptQuote`,
          method: 'POST',
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            contractId: queryArg.contractId,
            printTitleIssueIds: queryArg.printTitleIssueIds,
            token: queryArg.token,
          },
        }),
        invalidatesTags: ['Account/PrintAdvert'],
      }),
      getV1AccountPrintAdvertIssueDates: build.query<
        GetV1AccountPrintAdvertIssueDatesResponse,
        GetV1AccountPrintAdvertIssueDatesParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/PrintAdvert/IssueDates`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            dataObjectId: queryArg.dataObjectId,
          },
        }),
        providesTags: ['Account/PrintAdvert'],
      }),
      getV1AccountPrintAdvertQuote: build.query<
        GetV1AccountPrintAdvertQuoteResponse,
        GetV1AccountPrintAdvertQuoteParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/PrintAdvert/Quote`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            dataObjectId: queryArg.dataObjectId,
            token: queryArg.token,
          },
        }),
        providesTags: ['Account/PrintAdvert'],
      }),
      getV1AccountPrintAdvertById: build.query<GetV1AccountPrintAdvertByIdResponse, GetV1AccountPrintAdvertByIdParams>({
        query: (queryArg) => ({
          url: `/v1/Account/PrintAdvert/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            platform: queryArg.platform,
          },
        }),
        providesTags: ['Account/PrintAdvert'],
      }),
      postV1AccountPrintAdvertPreview: build.mutation<
        PostV1AccountPrintAdvertPreviewResponse,
        PostV1AccountPrintAdvertPreviewParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/PrintAdvert/Preview`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/PrintAdvert'],
      }),
      postV1AccountPrintAdvertPublish: build.mutation<
        PostV1AccountPrintAdvertPublishResponse,
        PostV1AccountPrintAdvertPublishParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/PrintAdvert/Publish`,
          method: 'POST',
          body: queryArg.accountPrintAdvertPublishPrintAdvertRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/PrintAdvert'],
      }),
      getV1AccountProducts: build.query<GetV1AccountProductsResponse, GetV1AccountProductsParams>({
        query: (queryArg) => ({
          url: `/v1/Account/Products`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            includeDisabled: queryArg.includeDisabled,
          },
        }),
        providesTags: ['Account/Products'],
      }),
      getV1AccountPublicationPrice: build.query<
        GetV1AccountPublicationPriceResponse,
        GetV1AccountPublicationPriceParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Publication/Price`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            productId: queryArg.productId,
            extensionProductIds: queryArg.extensionProductIds,
            billingAddressId: queryArg.billingAddressId,
          },
        }),
        providesTags: ['Account/Publication'],
      }),
      getV1AccountPublicationOptions: build.query<
        GetV1AccountPublicationOptionsResponse,
        GetV1AccountPublicationOptionsParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Publication/Options`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            dataObjectId: queryArg.dataObjectId,
            categoryId: queryArg.categoryId,
            dataObjectType: queryArg.dataObjectType,
          },
        }),
        providesTags: ['Account/Publication'],
      }),
      getV1AccountPublicationDataObjectById: build.query<
        GetV1AccountPublicationDataObjectByIdResponse,
        GetV1AccountPublicationDataObjectByIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Publication/DataObject/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            statuses: queryArg.statuses,
          },
        }),
        providesTags: ['Account/Publication'],
      }),
      postV1AccountPublicationDataObjectById: build.mutation<
        PostV1AccountPublicationDataObjectByIdResponse,
        PostV1AccountPublicationDataObjectByIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/Account/Publication/DataObject/${queryArg.id}`,
          method: 'POST',
          body: queryArg.accountPublicationPublishDataObjectRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Account/Publication'],
      }),
      getV1Attribute: build.query<GetV1AttributeResponse, GetV1AttributeParams>({
        query: (queryArg) => ({
          url: `/v1/Attribute`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            categoryIds: queryArg.categoryIds,
            objectTypeId: queryArg.objectTypeId,
            includeDisabled: queryArg.includeDisabled,
            onlySearchable: queryArg.onlySearchable,
            includeEntries: queryArg.includeEntries,
          },
        }),
        providesTags: ['Attribute'],
      }),
      getV1AttributeEntries: build.query<GetV1AttributeEntriesResponse, GetV1AttributeEntriesParams>({
        query: (queryArg) => ({
          url: `/v1/Attribute/Entries`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            dataAttributeId: queryArg.dataAttributeId,
            entryIds: queryArg.entryIds,
            parentEntryIds: queryArg.parentEntryIds,
            filter: queryArg.filter,
            maxCount: queryArg.maxCount,
          },
        }),
        providesTags: ['Attribute'],
      }),
      getV1Autocomplete: build.query<GetV1AutocompleteResponse, GetV1AutocompleteParams>({
        query: (queryArg) => ({
          url: `/v1/Autocomplete`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            text: queryArg.text,
          },
        }),
        providesTags: ['Autocomplete'],
      }),
      getV1Category: build.query<GetV1CategoryResponse, GetV1CategoryParams>({
        query: (queryArg) => ({
          url: `/v1/Category`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            parentId: queryArg.parentId,
            recursive: queryArg.recursive,
          },
        }),
        providesTags: ['Category'],
      }),
      getV1ConfigurationPlatforms: build.query<GetV1ConfigurationPlatformsResponse, GetV1ConfigurationPlatformsParams>({
        query: (queryArg) => ({
          url: `/v1/Configuration/Platforms`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Configuration'],
      }),
      getV1DataObjectCount: build.query<GetV1DataObjectCountResponse, GetV1DataObjectCountParams>({
        query: (queryArg) => ({
          url: `/v1/DataObject/Count`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            query: queryArg.query,
            categories: queryArg.categories,
            attributeEntries: queryArg.attributeEntries,
            attributeRanges: queryArg.attributeRanges,
            attributeTexts: queryArg.attributeTexts,
            regions: queryArg.regions,
            accountId: queryArg.accountId,
            accountGroupId: queryArg.accountGroupId,
            objectIds: queryArg.objectIds,
            locationRadius: queryArg.locationRadius,
            location: queryArg.location,
            locationIds: queryArg.locationIds,
            dateFrom: queryArg.dateFrom,
            dateTo: queryArg.dateTo,
            timestampFrom: queryArg.timestampFrom,
            timestampTo: queryArg.timestampTo,
            pageIndex: queryArg.pageIndex,
            pageSize: queryArg.pageSize,
            sortField: queryArg.sortField,
            sortOrder: queryArg.sortOrder,
            attributeKeys: queryArg.attributeKeys,
            includeDisabled: queryArg.includeDisabled,
            calculateAggregates: queryArg.calculateAggregates,
            onlyTopListed: queryArg.onlyTopListed,
            onlyRentals: queryArg.onlyRentals,
            longitude: queryArg.longitude,
            latitude: queryArg.latitude,
          },
        }),
        providesTags: ['DataObject'],
      }),
      getV1DataObjectById: build.query<GetV1DataObjectByIdResponse, GetV1DataObjectByIdParams>({
        query: (queryArg) => ({
          url: `/v1/DataObject/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['DataObject'],
      }),
      getV1DataObject: build.query<GetV1DataObjectResponse, GetV1DataObjectParams>({
        query: (queryArg) => ({
          url: `/v1/DataObject`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            maxDescriptionLength: queryArg.maxDescriptionLength,
            topListingCount: queryArg.topListingCount,
            query: queryArg.query,
            categories: queryArg.categories,
            attributeEntries: queryArg.attributeEntries,
            attributeRanges: queryArg.attributeRanges,
            attributeTexts: queryArg.attributeTexts,
            regions: queryArg.regions,
            accountId: queryArg.accountId,
            accountGroupId: queryArg.accountGroupId,
            objectIds: queryArg.objectIds,
            locationRadius: queryArg.locationRadius,
            location: queryArg.location,
            locationIds: queryArg.locationIds,
            dateFrom: queryArg.dateFrom,
            dateTo: queryArg.dateTo,
            timestampFrom: queryArg.timestampFrom,
            timestampTo: queryArg.timestampTo,
            pageIndex: queryArg.pageIndex,
            pageSize: queryArg.pageSize,
            sortField: queryArg.sortField,
            sortOrder: queryArg.sortOrder,
            attributeKeys: queryArg.attributeKeys,
            includeDisabled: queryArg.includeDisabled,
            calculateAggregates: queryArg.calculateAggregates,
            onlyTopListed: queryArg.onlyTopListed,
            onlyRentals: queryArg.onlyRentals,
            longitude: queryArg.longitude,
            latitude: queryArg.latitude,
          },
        }),
        providesTags: ['DataObject'],
      }),
      postV1DataObjectByIdContact: build.mutation<
        PostV1DataObjectByIdContactResponse,
        PostV1DataObjectByIdContactParams
      >({
        query: (queryArg) => ({
          url: `/v1/DataObject/${queryArg.id}/Contact`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['DataObject'],
      }),
      postV1DataObjectByIdReport: build.mutation<PostV1DataObjectByIdReportResponse, PostV1DataObjectByIdReportParams>({
        query: (queryArg) => ({
          url: `/v1/DataObject/${queryArg.id}/Report`,
          method: 'POST',
          body: queryArg.publicDataObjectReportRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['DataObject'],
      }),
      getV1Favorite: build.query<GetV1FavoriteResponse, GetV1FavoriteParams>({
        query: (queryArg) => ({
          url: `/v1/Favorite`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Favorite'],
      }),
      deleteV1Favorite: build.mutation<DeleteV1FavoriteResponse, DeleteV1FavoriteParams>({
        query: (queryArg) => ({
          url: `/v1/Favorite`,
          method: 'DELETE',
          body: queryArg.publicFavoritesRemoveFavoritesRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Favorite'],
      }),
      postV1Favorite: build.mutation<PostV1FavoriteResponse, PostV1FavoriteParams>({
        query: (queryArg) => ({
          url: `/v1/Favorite`,
          method: 'POST',
          body: queryArg.publicFavoritesSaveFavoritesRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Favorite'],
      }),
      getV1FileAdvertListPdfByAccountId: build.query<
        GetV1FileAdvertListPdfByAccountIdResponse,
        GetV1FileAdvertListPdfByAccountIdParams
      >({
        query: (queryArg) => ({
          url: `/v1/File/AdvertListPdf/${queryArg.accountId}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            platform: queryArg.platform,
          },
        }),
        providesTags: ['File'],
      }),
      getV1FileById: build.query<GetV1FileByIdResponse, GetV1FileByIdParams>({
        query: (queryArg) => ({
          url: `/v1/File/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            width: queryArg.width,
            height: queryArg.height,
            format: queryArg.format,
          },
        }),
        providesTags: ['File'],
      }),
      getV1FileTemporaryById: build.query<GetV1FileTemporaryByIdResponse, GetV1FileTemporaryByIdParams>({
        query: (queryArg) => ({
          url: `/v1/File/Temporary/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['File'],
      }),
      getV1GeoLocations: build.query<GetV1GeoLocationsResponse, GetV1GeoLocationsParams>({
        query: (queryArg) => ({
          url: `/v1/Geo/Locations`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            filter: queryArg.filter,
            maxCount: queryArg.maxCount,
            distinctByName: queryArg.distinctByName,
            ids: queryArg.ids,
          },
        }),
        providesTags: ['Geo'],
      }),
      getV1GeoRegions: build.query<GetV1GeoRegionsResponse, GetV1GeoRegionsParams>({
        query: (queryArg) => ({
          url: `/v1/Geo/Regions`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            filter: queryArg.filter,
            ids: queryArg.ids,
          },
        }),
        providesTags: ['Geo'],
      }),
      getV1PrintTitleNextIssueInfo: build.query<
        GetV1PrintTitleNextIssueInfoResponse,
        GetV1PrintTitleNextIssueInfoParams
      >({
        query: (queryArg) => ({
          url: `/v1/PrintTitle/NextIssueInfo`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            printTitleName: queryArg.printTitleName,
          },
        }),
        providesTags: ['PrintTitle'],
      }),
      putV1SearchAlertsByIdActivate: build.mutation<
        PutV1SearchAlertsByIdActivateResponse,
        PutV1SearchAlertsByIdActivateParams
      >({
        query: (queryArg) => ({
          url: `/v1/SearchAlerts/${queryArg.id}/Activate`,
          method: 'PUT',
          body: queryArg.publicSearchAlertsActivateSearchAlertRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['SearchAlerts'],
      }),
      postV1SearchAlerts: build.mutation<PostV1SearchAlertsResponse, PostV1SearchAlertsParams>({
        query: (queryArg) => ({
          url: `/v1/SearchAlerts`,
          method: 'POST',
          body: queryArg.publicSearchAlertsCreateSearchAlertRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['SearchAlerts'],
      }),
      getV1SearchAlerts: build.query<GetV1SearchAlertsResponse, GetV1SearchAlertsParams>({
        query: (queryArg) => ({
          url: `/v1/SearchAlerts`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            token: queryArg.token,
            includeAllPlatforms: queryArg.includeAllPlatforms,
          },
        }),
        providesTags: ['SearchAlerts'],
      }),
      deleteV1SearchAlertsById: build.mutation<DeleteV1SearchAlertsByIdResponse, DeleteV1SearchAlertsByIdParams>({
        query: (queryArg) => ({
          url: `/v1/SearchAlerts/${queryArg.id}`,
          method: 'DELETE',
          body: queryArg.publicSearchAlertsDeleteSearchAlertRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['SearchAlerts'],
      }),
      getV1SearchAlertsById: build.query<GetV1SearchAlertsByIdResponse, GetV1SearchAlertsByIdParams>({
        query: (queryArg) => ({
          url: `/v1/SearchAlerts/${queryArg.id}`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            token: queryArg.token,
          },
        }),
        providesTags: ['SearchAlerts'],
      }),
      putV1SearchAlertsById: build.mutation<PutV1SearchAlertsByIdResponse, PutV1SearchAlertsByIdParams>({
        query: (queryArg) => ({
          url: `/v1/SearchAlerts/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.publicSearchAlertsUpdateSearchAlertRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['SearchAlerts'],
      }),
      putV1SearchAlertsByIdInteraction: build.mutation<
        PutV1SearchAlertsByIdInteractionResponse,
        PutV1SearchAlertsByIdInteractionParams
      >({
        query: (queryArg) => ({
          url: `/v1/SearchAlerts/${queryArg.id}/Interaction`,
          method: 'PUT',
          body: queryArg.publicSearchAlertsUpdateInteractionDateRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['SearchAlerts'],
      }),
      getV1SeoPageContent: build.query<GetV1SeoPageContentResponse, GetV1SeoPageContentParams>({
        query: (queryArg) => ({
          url: `/v1/Seo/PageContent`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            url: queryArg.url,
          },
        }),
        providesTags: ['Seo'],
      }),
      getV1SeoUrls: build.query<GetV1SeoUrlsResponse, GetV1SeoUrlsParams>({
        query: (queryArg) => ({
          url: `/v1/Seo/Urls`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        providesTags: ['Seo'],
      }),
      getV1SeoRedirect: build.query<GetV1SeoRedirectResponse, GetV1SeoRedirectParams>({
        query: (queryArg) => ({
          url: `/v1/Seo/Redirect`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            path: queryArg.path,
            locale: queryArg.locale,
          },
        }),
        providesTags: ['Seo'],
      }),
      postV1Statistics: build.mutation<PostV1StatisticsResponse, PostV1StatisticsParams>({
        query: (queryArg) => ({
          url: `/v1/Statistics`,
          method: 'POST',
          body: queryArg.publicStatisticsCreateRequest,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
        }),
        invalidatesTags: ['Statistics'],
      }),
      getV1StatisticsImage: build.query<GetV1StatisticsImageResponse, GetV1StatisticsImageParams>({
        query: (queryArg) => ({
          url: `/v1/Statistics/Image`,
          headers: {
            'Accept-Language': queryArg['Accept-Language'],
            'X-AccountId': queryArg['X-AccountId'],
            'X-Platform': queryArg['X-Platform'],
          },
          params: {
            type: queryArg['type'],
            id: queryArg.id,
            additionalData: queryArg.additionalData,
            sessionId: queryArg.sessionId,
            timestamp: queryArg.timestamp,
          },
        }),
        providesTags: ['Statistics'],
      }),
      getServiceImportServiceAsmx: build.query<GetServiceImportServiceAsmxResponse, GetServiceImportServiceAsmxParams>({
        query: (queryArg) => ({
          url: `/service/import/service.asmx`,
          params: {
            'api-version': queryArg['api-version'],
          },
        }),
        providesTags: ['XmlFtpImport'],
      }),
      getServiceImportServiceAsmxIcw: build.query<
        GetServiceImportServiceAsmxIcwResponse,
        GetServiceImportServiceAsmxIcwParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/ICW`,
          params: {
            memberId: queryArg.memberId,
            filename: queryArg.filename,
            'api-version': queryArg['api-version'],
          },
        }),
        providesTags: ['XmlFtpImport'],
      }),
      postServiceImportServiceAsmxIcw: build.mutation<
        PostServiceImportServiceAsmxIcwResponse,
        PostServiceImportServiceAsmxIcwParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/ICW`,
          method: 'POST',
          body: queryArg.body,
          params: {
            'api-version': queryArg['api-version'],
          },
        }),
        invalidatesTags: ['XmlFtpImport'],
      }),
      getServiceImportServiceAsmxIrw: build.query<
        GetServiceImportServiceAsmxIrwResponse,
        GetServiceImportServiceAsmxIrwParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/IRW`,
          params: {
            memberId: queryArg.memberId,
            filename: queryArg.filename,
            'api-version': queryArg['api-version'],
          },
        }),
        providesTags: ['XmlFtpImport'],
      }),
      postServiceImportServiceAsmxIrw: build.mutation<
        PostServiceImportServiceAsmxIrwResponse,
        PostServiceImportServiceAsmxIrwParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/IRW`,
          method: 'POST',
          body: queryArg.body,
          params: {
            'api-version': queryArg['api-version'],
          },
        }),
        invalidatesTags: ['XmlFtpImport'],
      }),
      getServiceImportServiceAsmxVerify: build.query<
        GetServiceImportServiceAsmxVerifyResponse,
        GetServiceImportServiceAsmxVerifyParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/Verify`,
          params: {
            memberId: queryArg.memberId,
            fileName: queryArg.fileName,
            'api-version': queryArg['api-version'],
          },
        }),
        providesTags: ['XmlFtpImport'],
      }),
      postServiceImportServiceAsmxVerify: build.mutation<
        PostServiceImportServiceAsmxVerifyResponse,
        PostServiceImportServiceAsmxVerifyParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/Verify`,
          method: 'POST',
          body: queryArg.body,
          params: {
            'api-version': queryArg['api-version'],
          },
        }),
        invalidatesTags: ['XmlFtpImport'],
      }),
      getServiceImportServiceAsmxCheckProcess: build.query<
        GetServiceImportServiceAsmxCheckProcessResponse,
        GetServiceImportServiceAsmxCheckProcessParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/CheckProcess`,
          params: {
            memberId: queryArg.memberId,
            'api-version': queryArg['api-version'],
          },
        }),
        providesTags: ['XmlFtpImport'],
      }),
      postServiceImportServiceAsmxCheckProcess: build.mutation<
        PostServiceImportServiceAsmxCheckProcessResponse,
        PostServiceImportServiceAsmxCheckProcessParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/CheckProcess`,
          method: 'POST',
          body: queryArg.body,
          params: {
            'api-version': queryArg['api-version'],
          },
        }),
        invalidatesTags: ['XmlFtpImport'],
      }),
      getServiceImportServiceAsmxClearFolder: build.query<
        GetServiceImportServiceAsmxClearFolderResponse,
        GetServiceImportServiceAsmxClearFolderParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/ClearFolder`,
          params: {
            memberId: queryArg.memberId,
            'api-version': queryArg['api-version'],
          },
        }),
        providesTags: ['XmlFtpImport'],
      }),
      postServiceImportServiceAsmxClearFolder: build.mutation<
        PostServiceImportServiceAsmxClearFolderResponse,
        PostServiceImportServiceAsmxClearFolderParams
      >({
        query: (queryArg) => ({
          url: `/service/import/service.asmx/ClearFolder`,
          method: 'POST',
          body: queryArg.body,
          params: {
            'api-version': queryArg['api-version'],
          },
        }),
        invalidatesTags: ['XmlFtpImport'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as api };
export type GetV1AccountByIdResponse = /** status 200 OK */ PublicAccountDetailResponse;
export type GetV1AccountByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountAccountResponse = /** status 200 OK */ AccountAccountCreateAccountResponse;
export type PostV1AccountAccountParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountAccountCreateAccountRequest: AccountAccountCreateAccountRequest;
};
export type GetV1AccountAccountResponse = /** status 200 OK */ AccountAccountListAccountsResponse;
export type GetV1AccountAccountParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountAccountByIdResponse = /** status 200 OK */ AccountAccountLoadAccountResponse;
export type GetV1AccountAccountByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountAccountByIdResponse = /** status 200 OK */ AccountAccountUpdateAccountResponse;
export type PutV1AccountAccountByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountAccountUpdateAccountRequest: AccountAccountUpdateAccountRequest;
};
export type GetV1AccountAccountLoginInfoResponse = /** status 200 OK */ AccountAccountLoadLoginInfoResponse;
export type GetV1AccountAccountLoginInfoParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountAccountLoginSettingsResponse = /** status 200 OK */ AccountAccountLoadLoginSettingsResponse;
export type GetV1AccountAccountLoginSettingsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountAccountLoginSettingsResponse = unknown;
export type PutV1AccountAccountLoginSettingsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountAccountUpdateLoginSettingsRequest: AccountAccountUpdateLoginSettingsRequest;
};
export type PostV1AccountAddressResponse = /** status 200 OK */ AccountAddressesCreateAddressResponse;
export type PostV1AccountAddressParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountAddressesCreateAddressRequest: AccountAddressesCreateAddressRequest;
};
export type GetV1AccountAddressResponse = /** status 200 OK */ AccountAddressesListAddressesResponse;
export type GetV1AccountAddressParams = {
  /** The requested address types SynCore.Address.Data.AddressType */
  types?: AddressType[];
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type DeleteV1AccountAddressByIdResponse = unknown;
export type DeleteV1AccountAddressByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountAddressByIdResponse = /** status 200 OK */ AccountAddressesUpdateAddressResponse;
export type PutV1AccountAddressByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountAddressesUpdateAddressRequest: AccountAddressesUpdateAddressRequest;
};
export type PostV1AccountApiKeysResponse = /** status 200 OK */ AccountApiKeysCreateApiKeyResponse;
export type PostV1AccountApiKeysParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountApiKeysCreateApiKeyRequest: AccountApiKeysCreateApiKeyRequest;
};
export type GetV1AccountApiKeysResponse = /** status 200 OK */ AccountApiKeysListApiKeysResponse;
export type GetV1AccountApiKeysParams = {
  includeRevoked?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountApiKeysByUidRevokeResponse = unknown;
export type PutV1AccountApiKeysByUidRevokeParams = {
  uid: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountApiLogsImportExecutionsByIdResponse =
  /** status 200 OK */ AccountApiLogsGetImportExecutionResponse;
export type GetV1AccountApiLogsImportExecutionsByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountApiLogsImportExecutionsResponse =
  /** status 200 OK */ AccountApiLogsGetImportExecutionsResponse;
export type GetV1AccountApiLogsImportExecutionsParams = {
  /** A string to filter the results by. */
  filter?: string;
  /** The page index (zero-based). */
  pageIndex?: number;
  /** The number of items per page. */
  pageSize?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountAttributeResponse = /** status 200 OK */ AccountAttributeAttributeListResponse;
export type GetV1AccountAttributeParams = {
  categoryId?: number;
  onlyEditable?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountCategoryResponse = /** status 200 OK */ AccountCategoryCategoryListResponse;
export type GetV1AccountCategoryParams = {
  parentId?: number;
  recursive?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountCategoryByIdResponse = /** status 200 OK */ AccountCategoryLoadCategoryResponse;
export type GetV1AccountCategoryByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountConfigurationDataObjectTypesResponse =
  /** status 200 OK */ AccountConfigurationDataObjectTypeListResponse;
export type GetV1AccountConfigurationDataObjectTypesParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountConfigurationProcessResponse = /** status 200 OK */ AccountConfigurationGetProcessResponse;
export type GetV1AccountConfigurationProcessParams = {
  /** The category ID. */
  categoryId?: number;
  /** The data object type. (1=Standard, 4=Print) */
  dataObjectType?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountContactMessagesAttachmentsByFileIdResponse = unknown;
export type GetV1AccountContactMessagesAttachmentsByFileIdParams = {
  /** The file ID, as listed on the message. */
  fileId: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountContactMessagesByIdResponse =
  /** status 200 OK */ AccountContactMessagesGetConversationResponse;
export type GetV1AccountContactMessagesByIdParams = {
  /** The conversation ID. */
  id: number;
  /** A string to filter the results by. */
  filter?: string;
  /** The page index (zero-based). */
  pageIndex?: number;
  /** The number of items per page. */
  pageSize?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountContactMessagesCountsResponse = /** status 200 OK */ AccountContactMessagesGetCountsResponse;
export type GetV1AccountContactMessagesCountsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountContactMessagesResponse = /** status 200 OK */ AccountContactMessagesListConversationsResponse;
export type GetV1AccountContactMessagesParams = {
  /** Only conversations about this advert. */
  dataObjectId?: number;
  /** Only one side of the caller's conversations: the enquiries about their own adverts, or the
    ones they sent themselves. Omit for both. */
  participant?: ContactParticipant;
  /** Only conversations that have unread messages. */
  unreadOnly?: boolean;
  /** A string to filter the results by. */
  filter?: string;
  /** The page index (zero-based). */
  pageIndex?: number;
  /** The number of items per page. */
  pageSize?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountContactMessagesReadResponse = /** status 200 OK */ AccountContactMessagesMarkReadResponse;
export type PutV1AccountContactMessagesReadParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request. Omit the IDs to mark every conversation. */
  accountContactMessagesMarkReadRequest: AccountContactMessagesMarkReadRequest;
};
export type PutV1AccountContactMessagesByIdUnreadResponse =
  /** status 200 OK */ AccountContactMessagesMarkUnreadResponse;
export type PutV1AccountContactMessagesByIdUnreadParams = {
  /** The conversation ID. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountContactMessagesByIdReplyResponse = /** status 200 OK */ AccountContactMessagesReplyResponse;
export type PostV1AccountContactMessagesByIdReplyParams = {
  /** The conversation ID. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request. */
  accountContactMessagesReplyRequest: AccountContactMessagesReplyRequest;
};
export type PostV1AccountContactPersonResponse = /** status 200 OK */ AccountContactPersonsCreateContactPersonResponse;
export type PostV1AccountContactPersonParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountContactPersonsCreateContactPersonRequest: AccountContactPersonsCreateContactPersonRequest;
};
export type GetV1AccountContactPersonResponse = /** status 200 OK */ AccountContactPersonsListContactPersonsResponse;
export type GetV1AccountContactPersonParams = {
  request?: AccountContactPersonsListContactPersonsRequest;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type DeleteV1AccountContactPersonByIdResponse = unknown;
export type DeleteV1AccountContactPersonByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountContactPersonByIdResponse =
  /** status 200 OK */ AccountContactPersonsUpdateContactPersonResponse;
export type PutV1AccountContactPersonByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountContactPersonsUpdateContactPersonRequest: AccountContactPersonsUpdateContactPersonRequest;
};
export type PostV1AccountContractsCreateResponse = unknown;
export type PostV1AccountContractsCreateParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountContractsCreateContractRequest: AccountContractsCreateContractRequest;
};
export type GetV1AccountContractsResponse = /** status 200 OK */ AccountContractsListContractsResponse;
export type GetV1AccountContractsParams = {
  /** When true includes expired contracts in the response. */
  includeExpired?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountContractsUpgradeResponse = unknown;
export type PostV1AccountContractsUpgradeParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountContractsUpgradeContractRequest: AccountContractsUpgradeContractRequest;
};
export type PutV1AccountDataObjectByIdActivateResponse = unknown;
export type PutV1AccountDataObjectByIdActivateParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountDataObjectResponse = /** status 200 OK */ AccountDataObjectCreateDataObjectResponse;
export type PostV1AccountDataObjectParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  body: {
    categoryId?: number;
    type?: number;
    billingAddressId?: number;
    contactAddressId?: number;
    locationAddressId?: number;
    contactPersonIds?: number[];
    values?: AccountSharedDataObjectValueRec[];
    properties?: AccountSharedDataObjectPropertyRec[];
    images?: AccountSharedFileRec[];
    documents?: AccountSharedFileRec[];
    verificationDocuments?: AccountSharedFileRec[];
    files?: Blob[];
  };
};
export type GetV1AccountDataObjectResponse = /** status 200 OK */ AccountDataObjectListDataObjectsResponse;
export type GetV1AccountDataObjectParams = {
  categoryId?: number;
  platform?: string;
  status?: DataObjectStatus[];
  topListed?: boolean;
  /** A string to filter the results by. */
  filter?: string;
  /** The page index (zero-based). */
  pageIndex?: number;
  /** The number of items per page. */
  pageSize?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountDataObjectByIdDeactivateResponse = unknown;
export type PutV1AccountDataObjectByIdDeactivateParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type DeleteV1AccountDataObjectByIdResponse = unknown;
export type DeleteV1AccountDataObjectByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountDataObjectByIdResponse = /** status 200 OK */ AccountDataObjectLoadDataObjectResponse;
export type GetV1AccountDataObjectByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountDataObjectByIdResponse = /** status 200 OK */ AccountDataObjectUpdateDataObjectResponse;
export type PutV1AccountDataObjectByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  body: {
    id?: number;
    billingAddressId?: number;
    contactAddressId?: number;
    locationAddressId?: number;
    contactPersonIds?: number[];
    values?: AccountSharedDataObjectValueRec[];
    properties?: AccountSharedDataObjectPropertyRec[];
    images?: AccountSharedFileRec[];
    documents?: AccountSharedFileRec[];
    verificationDocuments?: AccountSharedFileRec[];
    files?: Blob[];
  };
};
export type PostV1AccountDataObjectByIdDuplicateResponse =
  /** status 200 OK */ AccountDataObjectDuplicateDataObjectResponse;
export type PostV1AccountDataObjectByIdDuplicateParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountDataObjectCountsResponse = /** status 200 OK */ AccountDataObjectDataObjectCountsResponse;
export type GetV1AccountDataObjectCountsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountDataObjectByIdTopListingResponse = unknown;
export type PutV1AccountDataObjectByIdTopListingParams = {
  /** The data object ID. */
  id: number;
  /** The requested top listing status. */
  active?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountLoginMigrationValidateResponse = unknown;
export type PostV1AccountLoginMigrationValidateParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountLoginMigrationValidateLoginRequest: AccountLoginMigrationValidateLoginRequest;
};
export type PutV1AccountLoginsAcceptInvitationResponse = unknown;
export type PutV1AccountLoginsAcceptInvitationParams = {
  /** The ID of the account to accept the invitation for. */
  accountId?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountLoginsResponse = unknown;
export type PostV1AccountLoginsParams = {
  /** The email address of the login to add. */
  email?: string;
  /** The role to assign to the login. */
  role?: AccountRole;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountLoginsResponse = /** status 200 OK */ SharedListResponseAccountLoginsListLoginsResponseItem;
export type GetV1AccountLoginsParams = {
  /** A string to filter the results by. */
  filter?: string;
  /** The page index (zero-based). */
  pageIndex?: number;
  /** The number of items per page. */
  pageSize?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountLoginsInvitationsResponse = /** status 200 OK */ AccountLoginsListInvitationsResponse;
export type GetV1AccountLoginsInvitationsParams = {
  token?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountLoginsRejectInvitationResponse = unknown;
export type PutV1AccountLoginsRejectInvitationParams = {
  accountId?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type DeleteV1AccountLoginsByIdResponse = unknown;
export type DeleteV1AccountLoginsByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1AccountLoginsSetRoleResponse = unknown;
export type PutV1AccountLoginsSetRoleParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountLoginsSetLoginRoleRequest: AccountLoginsSetLoginRoleRequest;
};
export type DeleteV1AccountLogoResponse = unknown;
export type DeleteV1AccountLogoParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountLogoResponse = /** status 200 OK */ AccountLogoSaveLogoResponse;
export type PostV1AccountLogoParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  body: {
    /** The logo image file. */
    file?: Blob;
  };
};
export type GetV1AccountLogoByAccountIdResponse = unknown;
export type GetV1AccountLogoByAccountIdParams = {
  /** The account ID. */
  accountId: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountPaymentsCreateResponse = /** status 200 OK */ AccountPaymentsCreatePaymentResponse;
export type PostV1AccountPaymentsCreateParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountPaymentsCreatePaymentRequest: AccountPaymentsCreatePaymentRequest;
};
export type GetV1AccountPaymentsContractResponse = /** status 200 OK */ AccountPaymentsGetContractDetailsResponse;
export type GetV1AccountPaymentsContractParams = {
  contractId?: number;
  token?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPaymentsOrderResponse = /** status 200 OK */ AccountPaymentsGetOrderDetailsResponse;
export type GetV1AccountPaymentsOrderParams = {
  id?: number;
  token?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPaymentsStatusResponse = /** status 200 OK */ AccountPaymentsGetPaymentStatusResponse;
export type GetV1AccountPaymentsStatusParams = {
  orderId?: number;
  token?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountPaymentsPrintOrderResponse = /** status 200 OK */ AccountPaymentsCreatePrintOrderResponse;
export type PostV1AccountPaymentsPrintOrderParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountPaymentsCreatePrintOrderRequest: AccountPaymentsCreatePrintOrderRequest;
};
export type PostV1AccountPaymentsCallbackByProviderNameTransactionResponse = unknown;
export type PostV1AccountPaymentsCallbackByProviderNameTransactionParams = {
  /** The name of the payment provider as configured. */
  providerName: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The API key to authenticate the request. */
  'X-Api-Key'?: any;
  /** The API key to authenticate the request. */
  apiKey?: any;
};
export type GetV1AccountPaymentsTokenResponse = /** status 200 OK */ string;
export type GetV1AccountPaymentsTokenParams = {
  contractId?: number;
  dataObjectId?: number;
  orderId?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountPrintAdvertAcceptQuoteResponse = unknown;
export type PostV1AccountPrintAdvertAcceptQuoteParams = {
  contractId?: number;
  printTitleIssueIds?: number[];
  token?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPrintAdvertIssueDatesResponse = /** status 200 OK */ AccountPrintAdvertLoadIssueDatesResponse;
export type GetV1AccountPrintAdvertIssueDatesParams = {
  dataObjectId?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPrintAdvertQuoteResponse = /** status 200 OK */ AccountPrintAdvertGetQuoteResponse;
export type GetV1AccountPrintAdvertQuoteParams = {
  dataObjectId?: number;
  token?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPrintAdvertByIdResponse = /** status 200 OK */ AccountPrintAdvertLoadPrintAdvertResponse;
export type GetV1AccountPrintAdvertByIdParams = {
  /** the dataObject Id of the advert */
  id: number;
  platform?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountPrintAdvertPreviewResponse = /** status 200 OK */ AccountPrintAdvertPreviewPrintAdvertResponse;
export type PostV1AccountPrintAdvertPreviewParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  body: {
    dataObjectId?: number;
    categoryId?: number;
    contextId?: string;
    removeImage?: boolean;
    values?: AccountSharedDataObjectValueRec[];
    imageFile?: Blob;
  };
};
export type PostV1AccountPrintAdvertPublishResponse = /** status 200 OK */ AccountPrintAdvertPublishPrintAdvertResponse;
export type PostV1AccountPrintAdvertPublishParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountPrintAdvertPublishPrintAdvertRequest: AccountPrintAdvertPublishPrintAdvertRequest;
};
export type GetV1AccountProductsResponse = /** status 200 OK */ AccountProductsListProductsResponse;
export type GetV1AccountProductsParams = {
  includeDisabled?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPublicationPriceResponse = /** status 200 OK */ AccountPublicationCalculatePriceResponse;
export type GetV1AccountPublicationPriceParams = {
  productId?: number;
  extensionProductIds?: number[];
  billingAddressId?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPublicationOptionsResponse =
  /** status 200 OK */ AccountPublicationPublicationOptionListResponse;
export type GetV1AccountPublicationOptionsParams = {
  dataObjectId?: number;
  categoryId?: number;
  dataObjectType?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AccountPublicationDataObjectByIdResponse =
  /** status 200 OK */ AccountPublicationPublicationListResponse;
export type GetV1AccountPublicationDataObjectByIdParams = {
  id: number;
  statuses?: PublicationStatus[];
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1AccountPublicationDataObjectByIdResponse =
  /** status 200 OK */ AccountPublicationPublishDataObjectResponse;
export type PostV1AccountPublicationDataObjectByIdParams = {
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  accountPublicationPublishDataObjectRequest: AccountPublicationPublishDataObjectRequest;
};
export type GetV1AttributeResponse = /** status 200 OK */ PublicAttributeListResponse;
export type GetV1AttributeParams = {
  /** Optional filter for specific category IDs. When null or empty will fall back to the current platform's root category. */
  categoryIds?: number[];
  /** Optional filter for a specific object type. */
  objectTypeId?: number;
  /** Specifies whether to include disabled attributes (defaults to false). */
  includeDisabled?: boolean;
  /** Specifies whether to only return attributes marked as searchable (defaults to false). */
  onlySearchable?: boolean;
  /** Specifies whether to include the entries of selection attributes (defaults to true). */
  includeEntries?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AttributeEntriesResponse = /** status 200 OK */ PublicAttributeGetEntryListResponse;
export type GetV1AttributeEntriesParams = {
  /** The selection attribute to read entries from. */
  dataAttributeId?: number;
  /** Optional filter for specific entry IDs, for resolving a known set of entries. */
  entryIds?: number[];
  /** Optional filter for entries below specific parent entries. */
  parentEntryIds?: number[];
  /** Optional text filter matched against the entry key and name. */
  filter?: string;
  /** Optional limit on the number of entries returned. */
  maxCount?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1AutocompleteResponse = /** status 200 OK */ PublicAutocompleteSearchAutocompleteResponse;
export type GetV1AutocompleteParams = {
  text?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1CategoryResponse = /** status 200 OK */ PublicCategoryListResponse;
export type GetV1CategoryParams = {
  /** When specified only returns children of the specified category, otherwise the root category ID of the current platform is used. */
  parentId?: number;
  /** Specifies whether to recursively populate the children (defaults to false). */
  recursive?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1ConfigurationPlatformsResponse = /** status 200 OK */ PublicConfigurationPlatformListResponse;
export type GetV1ConfigurationPlatformsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1DataObjectCountResponse = /** status 200 OK */ PublicDataObjectCountResponse;
export type GetV1DataObjectCountParams = {
  /** A query string to search for. */
  query?: string;
  /** Filter for category IDs. */
  categories?: number[];
  /** Filter for attribute entry IDs. */
  attributeEntries?: number[];
  /** Filter for attribute value ranges. */
  attributeRanges?: AttributeRange[];
  /** Filter for attribute text values. */
  attributeTexts?: AttributeText[];
  /** Filter for region IDs */
  regions?: number[];
  /** Filter for an account ID (list all ads owned by an account). */
  accountId?: number;
  /** Filter for an account group ID (list all ads owned by all accounts in the group). */
  accountGroupId?: number;
  /** Filter for getting specific objects (i.e. favorites). */
  objectIds?: number[];
  /** The radius in km to search for around Latitude and Longitude. */
  locationRadius?: number;
  /** A generic location search query. */
  location?: string;
  /** Filter for location IDs. */
  locationIds?: number[];
  /** Filter range start for the date where an ad was posted. */
  dateFrom?: string;
  /** Filter range end for the date where an ad was posted. */
  dateTo?: string;
  /** Filter range start for the date where an ad was indexed. */
  timestampFrom?: string;
  /** Filter range start for the date where an ad was indexed. */
  timestampTo?: string;
  /** The page index (0-based). */
  pageIndex?: number;
  /** The number of items per page. */
  pageSize?: number;
  /** The field name to sort by. */
  sortField?: SortField;
  /** The order when sorting. */
  sortOrder?: SortOrder;
  /** A list of attribute keys to include in the result items. If this is omitted or false, no attribute values are returned. */
  attributeKeys?: string[];
  /** When true will include disabled objects in the response. */
  includeDisabled?: boolean;
  /** Specifies whether to calculate aggregates (i.e. category & attribute counts). */
  calculateAggregates?: boolean;
  /** When true will only return objects flagged as top listed. */
  onlyTopListed?: boolean;
  /** When true will only return objects flagged as rentals. */
  onlyRentals?: boolean;
  /** Filter for geo location (in combination with LocationRadius). */
  longitude?: number;
  /** Filter for geo location (in combination with LocationRadius). */
  latitude?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1DataObjectByIdResponse = /** status 200 OK */ PublicDataObjectDetailResponse;
export type GetV1DataObjectByIdParams = {
  /** The data object ID. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1DataObjectResponse = /** status 200 OK */ PublicDataObjectListResponse;
export type GetV1DataObjectParams = {
  /** The maximum number of characters to return for item descriptions. 0 means descriptions are not returned, -1 means the full description text is returned. Defaults to 0. */
  maxDescriptionLength?: number;
  /** The number of top listings to return. */
  topListingCount?: number;
  /** A query string to search for. */
  query?: string;
  /** Filter for category IDs. */
  categories?: number[];
  /** Filter for attribute entry IDs. */
  attributeEntries?: number[];
  /** Filter for attribute value ranges. */
  attributeRanges?: AttributeRange[];
  /** Filter for attribute text values. */
  attributeTexts?: AttributeText[];
  /** Filter for region IDs */
  regions?: number[];
  /** Filter for an account ID (list all ads owned by an account). */
  accountId?: number;
  /** Filter for an account group ID (list all ads owned by all accounts in the group). */
  accountGroupId?: number;
  /** Filter for getting specific objects (i.e. favorites). */
  objectIds?: number[];
  /** The radius in km to search for around Latitude and Longitude. */
  locationRadius?: number;
  /** A generic location search query. */
  location?: string;
  /** Filter for location IDs. */
  locationIds?: number[];
  /** Filter range start for the date where an ad was posted. */
  dateFrom?: string;
  /** Filter range end for the date where an ad was posted. */
  dateTo?: string;
  /** Filter range start for the date where an ad was indexed. */
  timestampFrom?: string;
  /** Filter range start for the date where an ad was indexed. */
  timestampTo?: string;
  /** The page index (0-based). */
  pageIndex?: number;
  /** The number of items per page. */
  pageSize?: number;
  /** The field name to sort by. */
  sortField?: SortField;
  /** The order when sorting. */
  sortOrder?: SortOrder;
  /** A list of attribute keys to include in the result items. If this is omitted or false, no attribute values are returned. */
  attributeKeys?: string[];
  /** When true will include disabled objects in the response. */
  includeDisabled?: boolean;
  /** Specifies whether to calculate aggregates (i.e. category & attribute counts). */
  calculateAggregates?: boolean;
  /** When true will only return objects flagged as top listed. */
  onlyTopListed?: boolean;
  /** When true will only return objects flagged as rentals. */
  onlyRentals?: boolean;
  /** Filter for geo location (in combination with LocationRadius). */
  longitude?: number;
  /** Filter for geo location (in combination with LocationRadius). */
  latitude?: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1DataObjectByIdContactResponse = unknown;
export type PostV1DataObjectByIdContactParams = {
  /** The data object ID. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  body: {
    /** The data object ID to create the contact message for. */
    dataObjectId?: number;
    /** The ID of the contact person that shall receive the message, if empty, it's sent to location or account address */
    contactPersonId?: number;
    /** The captcha verification string (i.e. ReCaptcha 'request'). */
    captcha?: string;
    /** A single input for name (firstname lastname or company name). Must not be empty if firstname or lastname is empty. */
    name?: string;
    /** The firstname of the contacting person. Must not be empty if Name is empty. */
    firstname?: string;
    /** The lastname of the contacting person. Must not be empty if Name is empty. */
    lastname?: string;
    /** The email address of the contacting person. */
    email?: string;
    /** The location of the contacting person. */
    location?: string;
    /** The phone number of the contacting person. */
    phoneNumber?: string;
    /** The contact message. */
    message?: string;
    /** A list of dynamic flag strings specifying additional details or steps about the contact message. */
    flags?: string[];
    /** A list of files that shall be sent along with the message. */
    files?: Blob[];
  };
};
export type PostV1DataObjectByIdReportResponse = unknown;
export type PostV1DataObjectByIdReportParams = {
  /** The data object ID. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request. */
  publicDataObjectReportRequest: PublicDataObjectReportRequest;
};
export type GetV1FavoriteResponse = /** status 200 OK */ PublicFavoritesFavoriteListResponse;
export type GetV1FavoriteParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type DeleteV1FavoriteResponse = /** status 200 OK */ PublicFavoritesRemoveFavoritesResponse;
export type DeleteV1FavoriteParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  publicFavoritesRemoveFavoritesRequest: PublicFavoritesRemoveFavoritesRequest;
};
export type PostV1FavoriteResponse = /** status 200 OK */ PublicFavoritesSaveFavoritesResponse;
export type PostV1FavoriteParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  publicFavoritesSaveFavoritesRequest: PublicFavoritesSaveFavoritesRequest;
};
export type GetV1FileAdvertListPdfByAccountIdResponse = unknown;
export type GetV1FileAdvertListPdfByAccountIdParams = {
  accountId: number;
  platform?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1FileByIdResponse = /** status 200 OK */ Blob;
export type GetV1FileByIdParams = {
  /** The ID of the file. */
  id: number;
  /** Optional width to resize an image to (only valid for image files). */
  width?: number;
  /** Optional height to resize an image to (only valid for image files). */
  height?: number;
  /** Optional target format to re-encode an image to (only valid for image files), e.g. "jpg". */
  format?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1FileTemporaryByIdResponse = unknown;
export type GetV1FileTemporaryByIdParams = {
  /** The ID of the file. */
  id: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1GeoLocationsResponse = /** status 200 OK */ PublicGeoLocationListResponse;
export type GetV1GeoLocationsParams = {
  /** The filter to search for. */
  filter?: string;
  /** The maximum number of items returned (defaults to 10). */
  maxCount?: number;
  /** When true, only the first of multiple locations with the same name is returned (i.e. multiple ZIP codes per location). */
  distinctByName?: boolean;
  /** An optional list of location IDs to return. */
  ids?: number[];
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1GeoRegionsResponse = /** status 200 OK */ PublicGeoRegionListResponse;
export type GetV1GeoRegionsParams = {
  /** Optional filter for region names. */
  filter?: string;
  /** Optional list of regions IDs to return. */
  ids?: number[];
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1PrintTitleNextIssueInfoResponse = /** status 200 OK */ LoadPrintTitleResponse;
export type GetV1PrintTitleNextIssueInfoParams = {
  printTitleName?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1SearchAlertsByIdActivateResponse = unknown;
export type PutV1SearchAlertsByIdActivateParams = {
  /** The ID of the search alert. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request body. */
  publicSearchAlertsActivateSearchAlertRequest: PublicSearchAlertsActivateSearchAlertRequest;
};
export type PostV1SearchAlertsResponse = /** status 200 OK */ PublicSearchAlertsCreateSearchAlertResponse;
export type PostV1SearchAlertsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The search alert parameters. */
  publicSearchAlertsCreateSearchAlertRequest: PublicSearchAlertsCreateSearchAlertRequest;
};
export type GetV1SearchAlertsResponse = /** status 200 OK */ PublicSearchAlertsListSearchAlertsResponse;
export type GetV1SearchAlertsParams = {
  /** A search alert JWT that is required if the request is not authenticated. */
  token?: string;
  /** When true, will return search alerts for all platforms. */
  includeAllPlatforms?: boolean;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type DeleteV1SearchAlertsByIdResponse = unknown;
export type DeleteV1SearchAlertsByIdParams = {
  /** The ID of the search alert. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request body. */
  publicSearchAlertsDeleteSearchAlertRequest: PublicSearchAlertsDeleteSearchAlertRequest;
};
export type GetV1SearchAlertsByIdResponse = /** status 200 OK */ PublicSearchAlertsSearchAlertDetailResponse;
export type GetV1SearchAlertsByIdParams = {
  /** The search alert ID. */
  id: number;
  /** The authentication JWT. */
  token?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PutV1SearchAlertsByIdResponse = unknown;
export type PutV1SearchAlertsByIdParams = {
  /** The ID of the search alert. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request body. */
  publicSearchAlertsUpdateSearchAlertRequest: PublicSearchAlertsUpdateSearchAlertRequest;
};
export type PutV1SearchAlertsByIdInteractionResponse = unknown;
export type PutV1SearchAlertsByIdInteractionParams = {
  /** The ID of the search alert. */
  id: number;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request body. */
  publicSearchAlertsUpdateInteractionDateRequest: PublicSearchAlertsUpdateInteractionDateRequest;
};
export type GetV1SeoPageContentResponse = /** status 200 OK */ PublicSeoPageContentResponse;
export type GetV1SeoPageContentParams = {
  /** Absolute url of the page that requests content, as the visitor sees it. Falls back to the
    referrer when omitted. */
  url?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1SeoUrlsResponse = /** status 200 OK */ PublicSeoSeoUrlListResponse;
export type GetV1SeoUrlsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetV1SeoRedirectResponse = /** status 200 OK */ PublicSeoResolveRedirectResponse;
export type GetV1SeoRedirectParams = {
  /** The request path, with or without its locale segment and slashes. */
  path?: string;
  /** Two letter locale of the request, used when the path carries none. */
  locale?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type PostV1StatisticsResponse = unknown;
export type PostV1StatisticsParams = {
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
  /** The request body. */
  publicStatisticsCreateRequest: PublicStatisticsCreateRequest;
};
export type GetV1StatisticsImageResponse = unknown;
export type GetV1StatisticsImageParams = {
  /** The entry type. */
  type?: string;
  /** An optional identifier. */
  id?: string;
  /** Additional custom data. */
  additionalData?: string;
  /** An optional session ID. When omitted, internal ASP.NET session ID is used. */
  sessionId?: string;
  /** A timestamp when the entry was created.
    If this is specified and the difference between the current time and the timestamp
    is bigger than a configured time span (10s per default), the entry is discarded. */
  timestamp?: string;
  /** Sets the language code for the request (i.e. 'en', 'de'). */
  'Accept-Language'?: any;
  /** Sets the account ID to use for the current request. */
  'X-AccountId'?: any;
  /** Explicitly sets the platform name to use for the request. */
  'X-Platform'?: any;
};
export type GetServiceImportServiceAsmxResponse = unknown;
export type GetServiceImportServiceAsmxParams = {
  /** The requested API version */
  'api-version'?: string;
};
export type GetServiceImportServiceAsmxIcwResponse = /** status 200 OK */ string[];
export type GetServiceImportServiceAsmxIcwParams = {
  memberId?: string;
  filename?: string;
  /** The requested API version */
  'api-version'?: string;
};
export type PostServiceImportServiceAsmxIcwResponse = /** status 200 OK */ string[];
export type PostServiceImportServiceAsmxIcwParams = {
  /** The requested API version */
  'api-version'?: string;
  body: {
    memberId?: string;
    filename?: string;
  };
};
export type GetServiceImportServiceAsmxIrwResponse = /** status 200 OK */ string[];
export type GetServiceImportServiceAsmxIrwParams = {
  memberId?: string;
  filename?: string;
  /** The requested API version */
  'api-version'?: string;
};
export type PostServiceImportServiceAsmxIrwResponse = /** status 200 OK */ string[];
export type PostServiceImportServiceAsmxIrwParams = {
  /** The requested API version */
  'api-version'?: string;
  body: {
    memberId?: string;
    filename?: string;
  };
};
export type GetServiceImportServiceAsmxVerifyResponse = unknown;
export type GetServiceImportServiceAsmxVerifyParams = {
  memberId?: string;
  fileName?: string;
  /** The requested API version */
  'api-version'?: string;
};
export type PostServiceImportServiceAsmxVerifyResponse = unknown;
export type PostServiceImportServiceAsmxVerifyParams = {
  /** The requested API version */
  'api-version'?: string;
  body: {
    memberId?: string;
    fileName?: string;
  };
};
export type GetServiceImportServiceAsmxCheckProcessResponse = unknown;
export type GetServiceImportServiceAsmxCheckProcessParams = {
  memberId?: string;
  /** The requested API version */
  'api-version'?: string;
};
export type PostServiceImportServiceAsmxCheckProcessResponse = unknown;
export type PostServiceImportServiceAsmxCheckProcessParams = {
  /** The requested API version */
  'api-version'?: string;
  body: {
    memberId?: string;
  };
};
export type GetServiceImportServiceAsmxClearFolderResponse = unknown;
export type GetServiceImportServiceAsmxClearFolderParams = {
  memberId?: string;
  /** The requested API version */
  'api-version'?: string;
};
export type PostServiceImportServiceAsmxClearFolderResponse = unknown;
export type PostServiceImportServiceAsmxClearFolderParams = {
  /** The requested API version */
  'api-version'?: string;
  body: {
    memberId?: string;
  };
};
export type PublicAccountDetailResponse = {
  id: number;
  name?: string | null;
  streetAndNo?: string | null;
  zipAndCity?: string | null;
  phone?: string | null;
  url?: string | null;
};
export type AccountGlobalsAccountType = 'Undefined' | 'Private' | 'Company';
export type AccountStatus =
  | 'Default'
  | 'HasAddress'
  | 'Verified'
  | 'RequiresPrepayment'
  | 'LockedLogin'
  | 'LockedPrint'
  | 'LockedClassifieds'
  | 'LockedFraud'
  | 'LockedSuspiciousActivity';
export type AddressType = 'Account' | 'MergedTwAccount' | 'Contact' | 'ContactPerson' | 'Billing';
export type GenderType = 'Unknown' | 'Male' | 'Female';
export type AddressStatus = 'New' | 'ToVerify' | 'Verified';
export type AccountAddressRec = {
  id: number;
  type: AddressType;
  gender: GenderType;
  firstname?: string | null;
  lastname?: string | null;
  company?: string | null;
  company2?: string | null;
  street: string;
  streetNo?: string | null;
  street2?: string | null;
  zip: string;
  city: string;
  email?: string | null;
  phone?: string | null;
  showPhone: boolean;
  mobile?: string | null;
  showMobile: boolean;
  acceptsWhatsApp: boolean;
  countryIso2: string;
  homepageUrl?: string | null;
  status: AddressStatus;
  accountSettings: {
    [key: string]: string | null;
  };
};
export type AccountModel = {
  accountId: number;
  description: string;
  accountType: AccountGlobalsAccountType;
  accountStatus: AccountStatus;
  isNew: boolean;
  isVerified: boolean;
  address?: AccountAddressRec;
  language?: string | null;
};
export type AccountAccountCreateAccountResponse = {
  account: AccountModel;
};
export type ErrorResultValidationError = {
  /** The name of the property that caused a validation error. */
  property: string;
  /** The validation message. */
  message: string;
};
export type ErrorResult = {
  /** The error message. */
  message: string;
  /** Optional validation error messages. */
  validation?: ErrorResultValidationError[] | null;
};
export type AddressRec = {
  id: number;
  type: AddressType;
  gender: GenderType;
  firstname?: string | null;
  lastname?: string | null;
  company?: string | null;
  company2?: string | null;
  street: string;
  streetNo?: string | null;
  street2?: string | null;
  zip: string;
  city: string;
  email?: string | null;
  phone?: string | null;
  showPhone: boolean;
  mobile?: string | null;
  showMobile: boolean;
  acceptsWhatsApp: boolean;
  countryIso2: string;
  homepageUrl?: string | null;
  status: AddressStatus;
};
export type AccountAccountCreateAccountRequest = {
  address: AddressRec;
};
export type AccountAccountListAccountsResponseListItemModel = {
  id: number;
  name: string;
  type: AccountGlobalsAccountType;
  isNew: boolean;
};
export type AccountAccountListAccountsResponse = {
  accounts: AccountAccountListAccountsResponseListItemModel[];
};
export type AccountAccountLoadAccountResponse = {
  account: AccountModel;
  isImpersonated: boolean;
};
export type AccountAccountUpdateAccountResponse = {
  account: AccountModel;
};
export type IAddressRec = {
  acceptsWhatsApp: boolean;
  city: string;
  company?: string | null;
  company2?: string | null;
  countryIso2: string;
  email?: string | null;
  firstname?: string | null;
  gender: GenderType;
  homepageUrl?: string | null;
  id: number;
  lastname?: string | null;
  mobile?: string | null;
  phone?: string | null;
  showMobile: boolean;
  showPhone: boolean;
  status: AddressStatus;
  street: string;
  street2?: string | null;
  streetNo?: string | null;
  type: AddressType;
  zip: string;
};
export type UpdateAccountModel = {
  accountId: number;
  address: IAddressRec;
};
export type AccountAccountUpdateAccountRequest = {
  account: UpdateAccountModel;
};
export type AccountAccountLoadLoginInfoResponse = {
  id: number;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  streetAddress?: string | null;
  city?: string | null;
  zipCode?: string | null;
  countryCode?: string | null;
};
export type AccountAccountLoadLoginSettingsResponse = {
  language?: string | null;
};
export type AccountAccountUpdateLoginSettingsRequest = {
  language?: string | null;
};
export type AccountAddressesCreateAddressResponse = {
  address: AddressRec;
};
export type AccountAddressesCreateAddressRequest = {
  address: AddressRec;
};
export type AccountAddressesListAddressesResponse = {
  /** a list of addresses */
  addresses: AddressRec[];
};
export type AccountAddressesUpdateAddressResponse = {
  address: AddressRec;
};
export type AccountAddressesUpdateAddressRequest = {
  address: AddressRec;
};
export type AccountApiKeysCreateApiKeyResponse = {
  uid: string;
  key: string;
};
export type AccountApiKeysCreateApiKeyRequest = {
  name?: string | null;
  validFrom?: string | null;
  validTo?: string | null;
};
export type AccountApiKeysListApiKeysApiKey = {
  uid: string;
  name?: string | null;
  validFrom: string;
  validTo?: string | null;
  isRevoked: boolean;
};
export type AccountApiKeysListApiKeysResponse = {
  apiKeys: AccountApiKeysListApiKeysApiKey[];
};
export type ImportMode = 'Push' | 'Pull';
export type ImportType = 'DataObject';
export type QueueStatus = 'Queued' | 'Started' | 'Finished';
export type ResultStatus = 'Success' | 'Warning' | 'Error';
export type ImportRequestVersion = 'V1';
export type AccountApiLogsGetImportExecutionResponse = {
  /** The execution ID. */
  id: number;
  mode: ImportMode;
  type: ImportType;
  queueStatus: QueueStatus;
  resultStatus?: ResultStatus;
  /** The source URL when Mode is Netiva.Classifieds.Exchange.ImportMode.Pull. */
  source?: string | null;
  requestVersion: ImportRequestVersion;
  /** The raw request body. */
  requestJson?: string | null;
  /** The raw result body. */
  resultJson?: string | null;
  /** The start date/time of the import. */
  startDate?: string | null;
  /** The end date/time of the import. */
  endDate?: string | null;
  /** The UID of the API key used to authenticate the request. */
  apiKeyUid?: string | null;
};
export type AccountApiLogsGetImportExecutionsImportExecutionResponse = {
  /** The ID. */
  id: number;
  mode: ImportMode;
  type: ImportType;
  queueStatus: QueueStatus;
  resultStatus?: ResultStatus;
  /** The source of the import data. In case of Netiva.Classifieds.Exchange.ImportMode.Push: The origin IP address. In case of Netiva.Classifieds.Exchange.ImportMode.Pull: The source data URL. */
  source: string;
  /** The start date/time of the import execution. */
  startDate?: string | null;
  /** The end date/time of the import execution. */
  endDate?: string | null;
  /** The UID of the API key used to authenticate the import. */
  apiKeyUid?: string | null;
};
export type AccountApiLogsGetImportExecutionsResponse = {
  totalCount: number;
  items: AccountApiLogsGetImportExecutionsImportExecutionResponse[];
};
export type DataAttributeType =
  | 'Integer'
  | 'Decimal'
  | 'Date'
  | 'Text'
  | 'Boolean'
  | 'SelectSingle'
  | 'SelectSingleSearchMulti'
  | 'SelectMultiOr'
  | 'SelectMultiAnd'
  | 'SelectMultiSearchSingle'
  | 'Price'
  | 'LayoutGroup'
  | 'MultilineText'
  | 'HTML'
  | 'HTMLEInserat'
  | 'RangeInteger'
  | 'RangeDate'
  | 'NormalizedText'
  | 'Markdown';
export type AccountAttributeAttributeListResponseAttributeEntry = {
  id: number;
  key?: string | null;
  name?: string | null;
  sortOrder: number;
  parentEntryId?: number | null;
};
export type AccountAttributeAttributeListResponseAttributeCondition = {
  attributeKey: string;
  value: string;
};
export type AccountAttributeAttributeListResponseAttribute = {
  id: number;
  type: DataAttributeType;
  key?: string | null;
  name?: string | null;
  parentId?: number | null;
  sortOrder: number;
  mandatory: boolean;
  editable: boolean;
  maxLength?: number | null;
  minValue?: number | null;
  maxValue?: number | null;
  items: AccountAttributeAttributeListResponseAttributeEntry[];
  conditions: AccountAttributeAttributeListResponseAttributeCondition[];
  settings: {
    [key: string]: string | null;
  };
};
export type AccountAttributeAttributeListResponse = {
  count: number;
  attributes: AccountAttributeAttributeListResponseAttribute[];
};
export type AccountCategoryCategoryListResponseCategory = {
  id: number;
  key?: string | null;
  name?: string | null;
  parentId?: number | null;
  children?: AccountCategoryCategoryListResponseCategory[] | null;
};
export type AccountCategoryCategoryListResponse = {
  categories: AccountCategoryCategoryListResponseCategory[];
};
export type AccountCategoryLoadCategoryResponse = {
  id: number;
  key?: string | null;
  name?: string | null;
  parentId?: number | null;
  description?: string | null;
  isEnabled: boolean;
  urlSlug?: string | null;
};
export type DataObjectType = 'Default' | 'EInserat' | 'ChMediaPdf' | 'CrossPlatformPdf' | 'Vacancy';
export type AccountConfigurationDataObjectTypeListResponseItem = {
  id: number;
  type: DataObjectType;
};
export type AccountConfigurationDataObjectTypeListResponse = {
  items: AccountConfigurationDataObjectTypeListResponseItem[];
};
export type AccountConfigurationGetProcessStepItemType = 'Attribute' | 'Component' | 'Property';
export type AccountConfigurationGetProcessResponseStepItem = {
  type: AccountConfigurationGetProcessStepItemType;
  /** An attribute ID if the item is tied to an attribute. */
  attributeId?: number | null;
  /** An attribute key if the item is tied to an attribute and the ID of the attribute is not known. */
  attributeKey?: string | null;
  /** A component name if a specific component should be rendered. */
  componentName?: string | null;
  /** The sort order to display the items in. */
  sortOrder: number;
};
export type AccountConfigurationGetProcessPrevNavigationType = 'Enabled' | 'Disabled' | 'Unsaved';
export type AccountConfigurationGetProcessNextNavigationType = 'Enabled' | 'Disabled' | 'Publish';
export type AccountConfigurationGetProcessResponseStep = {
  /** The step key/ID. */
  key: string;
  /** The resource key of the title localisation. */
  titleResourceKey: string;
  /** The resource key of the description localisation. */
  introResourceKey?: string | null;
  /** The items to show on the step (attributes, components). */
  items: AccountConfigurationGetProcessResponseStepItem[];
  /** When true, a preview of the final ad should be visible on the step. */
  showPreview: boolean;
  /** When true, a price summary should be visible on the step. */
  showPriceSummary: boolean;
  /** When true, the total amount should be displayed in the price summary (i.e. amount per issue times the number of issues selected). */
  showPriceSummaryTotal: boolean;
  /** When true, the step is not shown in the navigation bar. */
  isHidden: boolean;
  prevNavigationType: AccountConfigurationGetProcessPrevNavigationType;
  nextNavigationType: AccountConfigurationGetProcessNextNavigationType;
};
export type AccountConfigurationGetProcessResponse = {
  /** The advertising process steps. */
  steps: AccountConfigurationGetProcessResponseStep[];
};
export type ContactParticipant = 'Advertiser' | 'Contact';
export type ContactMessageDirection = 'Incoming' | 'Outgoing';
export type AccountContactMessagesGetConversationResponseProperty = {
  /** The property key. */
  key: string;
  /** The property value. */
  value: string;
};
export type AccountContactMessagesGetConversationResponseAttachment = {
  /** The file ID. */
  id: number;
  /** The original file name. */
  name?: string | null;
  /** The file size in bytes. */
  size?: string | null;
  /** The content type. */
  mimeType?: string | null;
};
export type AccountContactMessagesGetConversationResponseMessage = {
  /** The message ID. */
  id: number;
  direction: ContactMessageDirection;
  /** The message text. */
  content?: string | null;
  /** When it was written. */
  dateCreated: string;
  /** Whether it has been read. */
  isRead: boolean;
  /** Details the contact form collected, such as phone and location. */
  properties: AccountContactMessagesGetConversationResponseProperty[];
  /** Files that came with the message. */
  attachments: AccountContactMessagesGetConversationResponseAttachment[];
};
export type AccountContactMessagesGetConversationResponse = {
  /** The conversation ID. */
  id: number;
  /** The advert the conversation is about, if any. */
  dataObjectId?: number | null;
  /** Title of that advert when the newest message arrived. */
  dataObjectTitle?: string | null;
  /** Email address of the contacting person. */
  contactEmail: string;
  /** Name of the contacting person, if they gave one. */
  contactName?: string | null;
  /** When the newest message was written. */
  lastMessageDate: string;
  participant: ContactParticipant;
  /** Messages in the conversation. */
  totalCount: number;
  /** The messages of the requested page, oldest first. */
  items: AccountContactMessagesGetConversationResponseMessage[];
};
export type AccountContactMessagesGetCountsResponse = {
  /** Unread messages across both sides of the caller's conversations. */
  totalUnread: number;
  /** Unread enquiries about the caller's own adverts. */
  advertiserUnread: number;
  /** Unread answers to enquiries the caller sent. */
  contactUnread: number;
};
export type AccountContactMessagesListConversationsResponseItem = {
  /** The conversation ID. */
  id: number;
  /** The advert the conversation is about, if any. */
  dataObjectId?: number | null;
  /** Title of that advert when the newest message arrived. */
  dataObjectTitle?: string | null;
  /** Email address of the contacting person. */
  contactEmail: string;
  /** Name of the contacting person, if they gave one. */
  contactName?: string | null;
  /** When the newest message was written. */
  lastMessageDate: string;
  /** The beginning of the newest message. */
  lastMessageSnippet?: string | null;
  lastMessageDirection?: ContactMessageDirection;
  /** Messages in the conversation, in both directions. */
  messageCount: number;
  /** Messages addressed to the caller that they have not read. */
  unreadCount: number;
  participant: ContactParticipant;
};
export type AccountContactMessagesListConversationsResponse = {
  /** Number of conversations matching the request. */
  totalCount: number;
  /** The conversations of the requested page. */
  items: AccountContactMessagesListConversationsResponseItem[];
};
export type AccountContactMessagesMarkReadResponse = {
  /** How many messages were marked read. */
  markedCount: number;
};
export type AccountContactMessagesMarkReadRequest = {
  /** The conversations to mark. Omit to mark every conversation of the account. */
  conversationIds?: number[] | null;
};
export type AccountContactMessagesMarkUnreadResponse = {
  /** How many messages were marked unread - zero when the conversation holds nothing incoming to
    mark, or already counted as unread. */
  markedCount: number;
};
export type AccountContactMessagesReplyResponse = {
  /** The ID of the stored reply. */
  id: number;
  /** When it was stored. */
  dateCreated: string;
};
export type AccountContactMessagesReplyRequest = {
  /** The answer. */
  content: string;
};
export type ContactPersonRec = {
  id: number;
  gender: GenderType;
  firstname?: string | null;
  lastname?: string | null;
  role?: string | null;
  language?: string | null;
  email?: string | null;
  phone?: string | null;
  mobile?: string | null;
};
export type AccountContactPersonsCreateContactPersonResponse = {
  contactPerson: ContactPersonRec;
};
export type AccountContactPersonsCreateContactPersonRequest = {
  contactPerson: ContactPersonRec;
};
export type AccountContactPersonsListContactPersonsResponse = {
  /** a list of contact persons */
  contactPersons: ContactPersonRec[];
};
export type AccountContactPersonsListContactPersonsRequest = object;
export type AccountContactPersonsUpdateContactPersonResponse = {
  contactPerson: ContactPersonRec;
};
export type AccountContactPersonsUpdateContactPersonRequest = {
  contactPerson: ContactPersonRec;
};
export type AccountContractsCreateContractRequest = {
  /** The product to assign to the contract. */
  productId: number;
};
export type ContractStatus = 'Undefined' | 'Unpaid' | 'PrepaymentRequired' | 'Paid' | 'Suspended';
export type AccountContractsListContractsResponseItemExtension = {
  id: number;
  productId: number;
};
export type AccountContractsListContractsResponseItem = {
  id: number;
  productId: number;
  price: number;
  quantity: number;
  publicationCount: number;
  startDate: string;
  endDate?: string | null;
  status: ContractStatus;
  extensions: AccountContractsListContractsResponseItemExtension[];
};
export type AccountContractsListContractsResponse = {
  items: AccountContractsListContractsResponseItem[];
};
export type AccountContractsUpgradeContractRequest = {
  /** The contract ID. */
  contractId: number;
  /** The new product ID. */
  productId: number;
};
export type DataObjectStatus =
  | 'Draft'
  | 'Active'
  | 'Disabled'
  | 'Deleted'
  | 'ToApprove'
  | 'Expired'
  | 'Approved'
  | 'ToApproveChanges';
export type AccountSharedDataObjectValueRec = {
  attributeId: number;
  value?: string | null;
  entries?: number[] | null;
};
export type AccountSharedDataObjectPropertyRec = {
  key: string;
  value?: string | null;
};
export type AccountSharedDataObjectRec = {
  id: number;
  type: number;
  categoryId: number;
  platform: string;
  status: DataObjectStatus;
  hasPendingChanges: boolean;
  billingAddressId?: number | null;
  contactAddressId?: number | null;
  locationAddressId?: number | null;
  contactPersonIds: number[];
  values: AccountSharedDataObjectValueRec[];
  properties: AccountSharedDataObjectPropertyRec[];
};
export type AccountDataObjectCreateDataObjectResponse = {
  dataObject: AccountSharedDataObjectRec;
};
export type AccountSharedFileRec = {
  id: number;
  fileName: string;
  url?: string | null;
  order?: number | null;
};
export type SharedPrice = {
  amount?: number | null;
  onRequest: boolean;
  vatClause?: string | null;
  currency?: string | null;
};
export type AccountDataObjectListDataObjectsResponseItem = {
  id: number;
  type: number;
  categoryId: number;
  status: DataObjectStatus;
  title: string;
  category?: string | null;
  platform?: string | null;
  publicUrl?: string | null;
  imageUrl?: string | null;
  description?: string | null;
  address?: string | null;
  addressStatus?: AddressStatus;
  price: SharedPrice;
  created: string;
  publicationStart?: string | null;
  publicationEnd?: string | null;
  allowDelete: boolean;
  allowDisable: boolean;
  allowEdit: boolean;
  allowEnable: boolean;
  allowExtending: boolean;
  allowTopListing: boolean;
  allowStop: boolean;
  isTopListed: boolean;
  viewCount: number;
  hasMessages: boolean;
  unreadMessageCount: number;
};
export type AccountDataObjectListDataObjectsResponse = {
  totalCount: number;
  items: AccountDataObjectListDataObjectsResponseItem[];
  categoryCounts: {
    [key: string]: number;
  };
  totalTopListingSlots: number;
  usedTopListingSlots: number;
  topListingProductId: number;
};
export type FileType =
  | 'Undefined'
  | 'Image'
  | 'TextDocument'
  | 'Pdf'
  | 'VerificationDocument'
  | 'PrintAdvertUploadedImg'
  | 'PrintAdvertRenderedPng'
  | 'PrintAdvertRenderedPdf'
  | 'AccountNote'
  | 'AccountLogo'
  | 'HomeBackground'
  | 'HomeBackgroundSm'
  | 'ContactAttachment';
export type SharedFileLocation = {
  type: string;
  url: string;
  mimeType?: string | null;
};
export type SharedFileMetadata = {
  key: string;
  value?: string | null;
};
export type SharedFile = {
  id: number;
  name: string;
  type: FileType;
  locations: SharedFileLocation[];
  metadata?: SharedFileMetadata[] | null;
};
export type AccountDataObjectLoadDataObjectResponse = {
  dataObject: AccountSharedDataObjectRec;
  files: SharedFile[];
};
export type AccountDataObjectUpdateDataObjectResponse = {
  dataObject: AccountSharedDataObjectRec;
};
export type AccountDataObjectDuplicateDataObjectResponse = {
  id: number;
};
export type AccountDataObjectDataObjectCountsResponse = {
  counts: {
    Draft: number;
    Active: number;
    Disabled: number;
    Deleted: number;
    ToApprove: number;
    Expired: number;
    Approved: number;
    ToApproveChanges: number;
  };
};
export type AccountLoginMigrationValidateLoginRequest = {
  email: string;
  password: string;
};
export type AccountRole = 'Invited' | 'Guest' | 'Member' | 'Admin' | 'Owner';
export type AccountLoginsListLoginsResponseItem = {
  id: number;
  email: string;
  isInvited: boolean;
  role?: AccountRole;
};
export type SharedListResponseAccountLoginsListLoginsResponseItem = {
  totalCount: number;
  items: AccountLoginsListLoginsResponseItem[];
};
export type AccountLoginsListInvitationsResponseResponseItem = {
  accountId: number;
  accountName: string;
};
export type AccountLoginsListInvitationsResponse = {
  items: AccountLoginsListInvitationsResponseResponseItem[];
};
export type AccountLoginsSetLoginRoleRequest = {
  /** The login ID. */
  id: number;
  role: AccountRole;
};
export type AccountLogoSaveLogoResponse = {
  fileId: number;
};
export type AccountPaymentsCreatePaymentResponse = {
  success: boolean;
  redirectUrl?: string | null;
};
export type AccountPaymentsCreatePaymentRequest = {
  orderId: number;
  returnUrl: string;
  provider?: string | null;
  token?: string | null;
};
export type PaymentStatus =
  | 'Created'
  | 'Failed'
  | 'Cancelled'
  | 'Complete'
  | 'Refunded'
  | 'PartiallyRefunded'
  | 'PendingRefund'
  | 'Chargeback'
  | 'Unhandled';
export type AccountPaymentsGetContractDetailsProduct = {
  id: number;
  name: string;
  price: number;
};
export type AccountPrintAdvertPrintAdvertRecPricePricePositionRec = {
  description: string;
  amount: number;
  isBasedOnHeight: boolean;
  currency: string;
};
export type AccountPrintAdvertPrintAdvertRecPrice = {
  productId: number;
  advertHeight: number;
  advertColumns: number;
  positions: AccountPrintAdvertPrintAdvertRecPricePricePositionRec[];
  amount: number;
  vatAmount: number;
  vatPercentage: number;
  grossAmount: number;
  currency: string;
};
export type AccountPaymentsGetContractDetailsPrintDetails = {
  imageUrl: string;
  issueDates: string[];
  price: AccountPrintAdvertPrintAdvertRecPrice;
};
export type AccountPaymentsGetContractDetailsResponse = {
  contractId: number;
  contractStatus: ContractStatus;
  billingAddressId: number;
  payBefore?: string | null;
  paymentStatus?: PaymentStatus;
  selectedPaymentProvider?: string | null;
  availablePaymentProviders: string[];
  product: AccountPaymentsGetContractDetailsProduct;
  extensionProducts: AccountPaymentsGetContractDetailsProduct[];
  dataObject?: AccountSharedDataObjectRec;
  printDetails?: AccountPaymentsGetContractDetailsPrintDetails;
  requiresPrepayment: boolean;
};
export type AccountPaymentsGetOrderDetailsOrderItem = {
  productId: number;
  quantity: number;
};
export type AccountPaymentsGetOrderDetailsResponse = {
  id: number;
  contractId?: number | null;
  mainProductId?: number | null;
  dataObjectId?: number | null;
  items: AccountPaymentsGetOrderDetailsOrderItem[];
};
export type AccountPaymentsGetPaymentStatusResponse = {
  status?: PaymentStatus;
  redirectUrl?: string | null;
  externalId?: string | null;
};
export type AccountPaymentsCreatePrintOrderResponse = {
  orderId: number;
};
export type AccountPaymentsCreatePrintOrderRequest = {
  contractId: number;
  token?: string | null;
};
export type AccountPrintAdvertLoadIssueDatesResponseItem = {
  id: number;
  date: string;
  closeDateTime: string;
};
export type AccountPrintAdvertLoadIssueDatesResponse = {
  dates: AccountPrintAdvertLoadIssueDatesResponseItem[];
};
export type AccountPrintAdvertGetQuoteContract = {
  id: number;
  status: ContractStatus;
};
export type AccountPrintAdvertGetQuoteResponse = {
  dataObject: AccountSharedDataObjectRec;
  contract: AccountPrintAdvertGetQuoteContract;
  imageUrl?: string | null;
  price: AccountPrintAdvertPrintAdvertRecPrice;
  selectedIssueIds: number[];
};
export type PaymentType = 'None' | 'Immediate' | 'ImmediateRequired' | 'AfterVerification';
export type AccountPrintAdvertPrintAdvertRecPaymentInfo = {
  productId: number;
  paymentType: PaymentType;
  paymentProviders: string[];
};
export type AccountPrintAdvertLoadPrintAdvertResponse = {
  dataObject: AccountSharedDataObjectRec;
  preview: AccountSharedFileRec;
  image?: AccountSharedFileRec;
  selectedIssueIds: number[];
  bookedIssueIds: number[];
  priceSummary: AccountPrintAdvertPrintAdvertRecPrice;
  paymentInfo: AccountPrintAdvertPrintAdvertRecPaymentInfo;
};
export type AccountPrintAdvertPreviewPrintAdvertResponse = {
  preview: AccountSharedFileRec;
  contextId: string;
  priceSummary: AccountPrintAdvertPrintAdvertRecPrice;
  paymentInfo: AccountPrintAdvertPrintAdvertRecPaymentInfo;
};
export type AccountPrintAdvertPublishPrintAdvertResponse = {
  orderId: number;
};
export type AccountPrintAdvertPublishPrintAdvertRequest = {
  dataObjectId: number;
  printTitleIssueIds: number[];
  paymentProvider?: string | null;
};
export type AccountProductsListProductsResponseItem = {
  id: number;
  name: string;
  description?: string | null;
  isDisabled: boolean;
  price: number;
  duration?: number | null;
  numberOfAds?: number | null;
  extensionProductIds: number[];
  group?: string | null;
  sku?: string | null;
  isHidden: boolean;
  isSlot: boolean;
  isCreatable: boolean;
  upgradeToGroups: string[];
};
export type AccountProductsListProductsResponse = {
  items: AccountProductsListProductsResponseItem[];
};
export type AccountPublicationCalculatePriceResponsePricePosition = {
  description: string;
  amount: number;
};
export type AccountPublicationCalculatePriceResponse = {
  netAmount: number;
  vatPercentage?: number | null;
  vatAmount?: number | null;
  grossAmount: number;
  currency: string;
  positions: AccountPublicationCalculatePriceResponsePricePosition[];
};
export type AccountPublicationPublicationOptionListResponseProduct = {
  id: number;
  name: string;
  description?: string | null;
  price: number;
  duration?: number | null;
  numberOfAds?: number | null;
  extensionProducts: AccountPublicationPublicationOptionListResponseProduct[];
  prolongationProducts: AccountPublicationPublicationOptionListResponseProduct[];
  group?: string | null;
  sku?: string | null;
  paymentProviders?: string[] | null;
  allowRemarks: boolean;
  allowPublicationDate: boolean;
  requiresVerification: boolean;
};
export type AccountPublicationPublicationOptionListResponseContractExtension = {
  id: number;
  product: AccountPublicationPublicationOptionListResponseProduct;
  price: number;
};
export type AccountPublicationPublicationOptionListResponseContract = {
  id: number;
  product: AccountPublicationPublicationOptionListResponseProduct;
  price: number;
  quantity: number;
  available: number;
  activeExtensions: AccountPublicationPublicationOptionListResponseContractExtension[];
  availableExtensions: AccountPublicationPublicationOptionListResponseProduct[];
  paymentProvider?: string | null;
};
export type PublicationStatus = 'Active' | 'Disabled' | 'Deleted' | 'Blocked';
export type AccountPublicationPublicationOptionListResponsePublication = {
  id: number;
  contract: AccountPublicationPublicationOptionListResponseContract;
  status: PublicationStatus;
  startDate: string;
  endDate?: string | null;
};
export type AccountPublicationPublicationOptionListResponse = {
  activePublication?: AccountPublicationPublicationOptionListResponsePublication;
  availableContracts?: AccountPublicationPublicationOptionListResponseContract[] | null;
  availableProducts?: AccountPublicationPublicationOptionListResponseProduct[] | null;
};
export type AccountPublicationPublicationListResponseItem = {
  id: number;
  contractId: number;
  dataObjectId: number;
  status: PublicationStatus;
  startDate: string;
  endDate?: string | null;
};
export type AccountPublicationPublicationListResponse = {
  items: AccountPublicationPublicationListResponseItem[];
};
export type AccountPublicationPublishDataObjectResponse = {
  orderId: number;
  publicationId?: number | null;
};
export type AccountPublicationPublishDataObjectRequest = {
  dataObjectId: number;
  contractId?: number | null;
  productId?: number | null;
  extensionProductIds?: number[] | null;
  billingAddressId?: number | null;
  paymentProvider?: string | null;
  remarks?: string | null;
  publicationDate?: string | null;
};
export type PublicAttributeListResponseAttributeEntry = {
  id: number;
  key?: string | null;
  name: string;
  sortOrder: number;
};
export type PublicAttributeListResponseAttribute = {
  id: number;
  key?: string | null;
  name: string;
  type: DataAttributeType;
  entries?: PublicAttributeListResponseAttributeEntry[] | null;
  entryCount: number;
  searchable: boolean;
  hidden: boolean;
  sortOrder: number;
  minValue?: number | null;
  maxValue?: number | null;
  parentId?: number | null;
};
export type PublicAttributeListResponse = {
  attributes: PublicAttributeListResponseAttribute[];
};
export type PublicAttributeGetEntryListResponseEntry = {
  id: number;
  key?: string | null;
  name: string;
  sortOrder: number;
  parentEntryId?: number | null;
};
export type PublicAttributeGetEntryListResponse = {
  items: PublicAttributeGetEntryListResponseEntry[];
};
export type PublicAutocompleteSearchAutocompleteAutocompleteMetadata = {
  key: string;
  value?: string | null;
};
export type PublicAutocompleteSearchAutocompleteAutocompleteItem = {
  value: string;
  metadata: PublicAutocompleteSearchAutocompleteAutocompleteMetadata[];
};
export type PublicAutocompleteSearchAutocompleteResponse = {
  items: PublicAutocompleteSearchAutocompleteAutocompleteItem[];
};
export type PublicCategoryListResponseCategory = {
  id: number;
  key?: string | null;
  name?: string | null;
  description?: string | null;
  parentId?: number | null;
  isTop: boolean;
  isFeatured: boolean;
  imagePath?: string | null;
  urlSlug?: string | null;
  sectionLabel?: string | null;
  highlightBadge?: string | null;
  children?: PublicCategoryListResponseCategory[] | null;
};
export type PublicCategoryListResponse = {
  categories: PublicCategoryListResponseCategory[];
};
export type PublicConfigurationPlatformListResponseDataObjectType = {
  id: number;
  type: DataObjectType;
};
export type PublicConfigurationPlatformListResponseItem = {
  key: string;
  name: string;
  dataObjectTypes: PublicConfigurationPlatformListResponseDataObjectType[];
  allowPrintList: boolean;
  accountBaseUrl: string;
  publicBaseUrl: string;
  group?: string | null;
  sortOrder?: number | null;
};
export type PublicConfigurationPlatformListResponse = {
  items: PublicConfigurationPlatformListResponseItem[];
};
export type PublicDataObjectCountResponse = {
  count: number;
};
export type AttributeRange = {
  id?: number | null;
  key?: string | null;
  numberMin?: number | null;
  numberMax?: number | null;
  dateMin?: string | null;
  dateMax?: string | null;
};
export type AttributeText = {
  id?: number | null;
  key?: string | null;
  value?: string | null;
};
export type SortField = 'Relevance' | 'Date' | 'Price' | 'Title' | 'PublicationDate';
export type SortOrder = 'Ascending' | 'Descending';
export type PublicDataObjectDetailRangeValue = {
  /** Min value of the range */
  min: string;
  /** Max value of the range */
  max: string;
};
export type PublicDataObjectDetailResponseAttributeValue = {
  /** The attribute ID. */
  id: number;
  /** The attribute key. */
  key?: string | null;
  /** The selected attribute entries (in case of a selection attribute). */
  entryIds?: number[] | null;
  range?: PublicDataObjectDetailRangeValue;
  /** The attribute value text (can also contain numeric values). */
  valueText?: string | null;
};
export type PublicDataObjectDetailPropertyType = 'Text' | 'Number' | 'Link';
export type PublicDataObjectDetailResponsePropertyValue = {
  /** The property key. */
  key: string;
  /** The property value. */
  value?: string | null;
  type: PublicDataObjectDetailPropertyType;
};
export type PublicDataObjectDetailResponseAccount = {
  /** The account ID. */
  id: number;
};
export type PublicDataObjectDetailResponsePhoneNumber = {
  /** The value from user input, freetext */
  display: string;
  /** normalized international number format */
  international?: string | null;
  /** Whether contacting per WhatsApp is accepted. */
  acceptsWhatsApp: boolean;
};
export type PublicDataObjectDetailResponseAddress = {
  /** The address ID. */
  id: number;
  /** The full name. */
  name?: string | null;
  /** The company name. */
  companyName?: string | null;
  /** The company name, 2nd/additional line. */
  companyNameSecondary?: string | null;
  /** The full street address. */
  street?: string | null;
  /** The ZIP code. */
  zipCode?: string | null;
  /** The city/location. */
  city?: string | null;
  /** A website URL. */
  url?: string | null;
  phone?: PublicDataObjectDetailResponsePhoneNumber;
  phoneMobile?: PublicDataObjectDetailResponsePhoneNumber;
  /** The latitude coordinate of the location. */
  latitude?: number | null;
  /** The longitude coordinate of the location. */
  longitude?: number | null;
  /** Indicates whether the address has a contact email (for Contact Button/Form) */
  hasContactEmail: boolean;
};
export type PublicDataObjectDetailResponseContactPerson = {
  id: number;
  name: string;
  phone?: PublicDataObjectDetailResponsePhoneNumber;
  phoneMobile?: PublicDataObjectDetailResponsePhoneNumber;
  /** The role of the ContactPerson (eg, Sales, Technical, German/French Speaking */
  role?: string | null;
  /** True if contact person has an email address */
  showContactForm: boolean;
};
export type PublicDataObjectDetailResponse = {
  /** The data object ID. */
  id: number;
  /** The object's category ID. */
  categoryId: number;
  /** The object's category path from root down to the assigned category (top down). */
  categoryIdPath: number[];
  /** The title. */
  title?: string | null;
  /** The description (may contain simple HTML formatting!). */
  description?: string | null;
  price?: SharedPrice;
  /** The date when the object was published. */
  datePosted?: string | null;
  /** A list of files (images, documents) attached to this object. */
  files: SharedFile[];
  /** A list of attributes. */
  attributes: PublicDataObjectDetailResponseAttributeValue[];
  /** A list of object property values. */
  properties: PublicDataObjectDetailResponsePropertyValue[];
  owner: PublicDataObjectDetailResponseAccount;
  /** The name of the supplier. */
  supplier?: string | null;
  /** The location string of the object. */
  location?: string | null;
  contactAddress?: PublicDataObjectDetailResponseAddress;
  /** A list of contact persons. */
  contactPersons: PublicDataObjectDetailResponseContactPerson[];
  /** Specifies whether the object is disabled (not available publicly). */
  isDisabled: boolean;
};
export type PublicDataObjectListResponseAttributeValue = {
  id?: number | null;
  key?: string | null;
  text: string;
};
export type PublicDataObjectListResponseAttribute = {
  id: number;
  type: DataAttributeType;
  key?: string | null;
  name: string;
  values: PublicDataObjectListResponseAttributeValue[];
  valueText?: string | null;
};
export type PublicDataObjectListResponseItem = {
  id: number;
  categoryId: number;
  title?: string | null;
  description?: string | null;
  price?: SharedPrice;
  image?: SharedFile;
  attributes?: PublicDataObjectListResponseAttribute[] | null;
  datePosted?: string | null;
  location?: string | null;
  supplier?: string | null;
  sourcePlatform?: string | null;
  isTopListed: boolean;
  isWanted: boolean;
};
export type PublicDataObjectListResponseAggregateContainer = {
  attributes: {
    [key: string]: number;
  };
  categories: {
    [key: string]: number;
  };
};
export type PublicDataObjectListResponse = {
  totalCount: number;
  pageSize: number;
  items: PublicDataObjectListResponseItem[];
  topListingItems: PublicDataObjectListResponseItem[];
  aggregates?: PublicDataObjectListResponseAggregateContainer;
  extensionData: {
    [key: string]: string;
  };
};
export type PublicDataObjectReportRequest = {
  dataObjectId: number;
  email: string;
  phone?: string | null;
  message?: string | null;
  captcha: string;
};
export type PublicFavoritesFavoriteListResponse = {
  dataObjectIds: number[];
};
export type PublicFavoritesRemoveFavoritesResponse = {
  /** All remaining favorite IDs for the current user/login. */
  dataObjectIds: number[];
};
export type PublicFavoritesRemoveFavoritesRequest = {
  /** The object IDs to remove from favorites for the current user/login. */
  dataObjectIds: number[];
};
export type PublicFavoritesSaveFavoritesResponse = {
  /** All current favorite IDs for the current user/login. */
  dataObjectIds: number[];
};
export type PublicFavoritesSaveFavoritesRequest = {
  /** The object IDs to save as favorites for the current user/login. */
  dataObjectIds: number[];
  /** When true existing favorites will be replaced with the current IDs. */
  replace?: boolean | null;
};
export type StatusCodeResult = {
  statusCode: number;
};
export type PublicGeoLocationListResponseItem = {
  /** The location ID. */
  id: number;
  /** The name of the location. */
  name: string;
  /** The ZIP code of the location. */
  zipCode?: string | null;
  /** The latitude (if available). */
  lat?: number | null;
  /** The longitude (if available). */
  lng?: number | null;
};
export type PublicGeoLocationListResponse = {
  items: PublicGeoLocationListResponseItem[];
};
export type PublicGeoRegionListResponseRegion = {
  id: number;
  name: string;
};
export type PublicGeoRegionListResponse = {
  regions: PublicGeoRegionListResponseRegion[];
};
export type LoadPrintTitleResponse = {
  issueName: string;
  issueDate: string;
  closeDate: string;
  isExtendedIssue: boolean;
  additionalCopies?: number | null;
};
export type PublicSearchAlertsActivateSearchAlertRequest = {
  id: number;
  token: string;
};
export type PublicSearchAlertsCreateSearchAlertResponse = {
  /** The ID of the search alert. */
  id: number;
  /** Indicates if the search alert requires activation. */
  requiresActivation: boolean;
};
export type SearchAlertParameters = {
  accountGroupId?: number | null;
  accountId?: number | null;
  attributeEntries?: number[] | null;
  attributeTexts?: AttributeText[] | null;
  attributeRanges?: AttributeRange[] | null;
  categories?: number[] | null;
  languageCode?: string | null;
  latitude?: number | null;
  location?: string | null;
  locationIds?: number[] | null;
  locationRadius?: number | null;
  longitude?: number | null;
  onlyRentals?: boolean | null;
  platform?: string | null;
  query?: string | null;
  regions?: number[] | null;
  sortField?: SortField;
  sortOrder?: SortOrder;
};
export type PublicSearchAlertsCreateSearchAlertRequest = {
  /** The email address. */
  email: string;
  /** The search alert name. */
  name?: string | null;
  parameters: SearchAlertParameters;
};
export type PublicSearchAlertsListSearchAlertsResponseItem = {
  /** The search alert ID. */
  id: number;
  /** The search alert name. */
  name?: string | null;
  /** Specifies whether the search alert is enabled/active. */
  isEnabled: boolean;
  parameters: SearchAlertParameters;
};
export type PublicSearchAlertsListSearchAlertsResponse = {
  /** Search alert items. */
  items: PublicSearchAlertsListSearchAlertsResponseItem[];
};
export type PublicSearchAlertsDeleteSearchAlertRequest = {
  /** The ID of the search alert. */
  id: number;
  /** A search alert JWT that is required if the request is not authenticated. */
  token?: string | null;
};
export type PublicSearchAlertsSearchAlertDetailResponse = {
  id: number;
  name?: string | null;
  email: string;
  isEnabled: boolean;
  parameters: SearchAlertParameters;
};
export type PublicSearchAlertsUpdateSearchAlertRequest = {
  /** The search alert ID. */
  id: number;
  /** The search alert name. */
  name?: string | null;
  /** Specifies whether the search alert is enabled or disabled. */
  isEnabled: boolean;
  /** A search alert JWT that is required if the request is unauthenticated. */
  token?: string | null;
  parameters: SearchAlertParameters;
};
export type PublicSearchAlertsUpdateInteractionDateRequest = {
  /** The search alert ID. */
  id: number;
  /** A search alert JWT that is required if the request is unauthenticated. */
  token?: string | null;
};
export type PublicSeoPageContentResponseMetaData = {
  title: string;
  description: string;
  /** Whether the category and attribute entry filters leave a URL worth indexing. The
    frontend decides the rest of the URL and indexes only where both agree. */
  indexable: boolean;
};
export type SeoContentType = 'SingleLine' | 'MultiLine' | 'Html' | 'Markdown';
export type PublicSeoPageContentResponseContentBlock = {
  /** The block name. */
  key: string;
  /** The block name, kept for backwards compatibility. */
  type: string;
  contentType: SeoContentType;
  /** The localized value. */
  content: string;
};
export type PublicSeoPageContentResponse = {
  pageMetaData: PublicSeoPageContentResponseMetaData;
  /** The page title. */
  pageTitle?: string | null;
  /** A list of content blocks. */
  contentBlocks: PublicSeoPageContentResponseContentBlock[];
};
export type PublicSeoSeoUrlListResponseRouteValue = {
  /** The SEO URL, without leading or trailing slashes. */
  url: string;
  /** The query string the URL rewrites to. */
  parameters: string;
  /** Two letter locale. */
  locale: string;
};
export type PublicSeoSeoUrlListResponseRoute = {
  /** The frontend route the values rewrite to, i.e. "search". */
  name: string;
  /** The URLs that map onto that route. */
  values: PublicSeoSeoUrlListResponseRouteValue[];
};
export type PublicSeoSeoUrlListResponseRedirect = {
  /** The URL to redirect away from, without leading or trailing slashes. */
  source: string;
  /** Where the redirect leads: a path relative to the locale of the request ("hunde"), a
    rooted path that carries its own locale ("/de/hunde"), or an absolute URL. May carry a
    query, and may end in a slash. */
  target: string;
  /** Two letter locale, or null when it applies to all locales. */
  locale?: string | null;
  /** True for a permanent (301) redirect. */
  permanent: boolean;
};
export type PublicSeoSeoUrlListResponseRewriteValue = {
  /** The URL as the visitor sees it, without leading or trailing slashes. */
  url: string;
  /** Two letter locale. */
  locale: string;
};
export type PublicSeoSeoUrlListResponseRewrite = {
  /** Identifies the landing page; its values are each other's alternates. */
  id: number;
  /** The app path and query the request is served from, without leading slash and without the
    locale. Always an internal route: a rewrite is not resolved a second time. */
  target: string;
  /** The URL per locale. */
  values: PublicSeoSeoUrlListResponseRewriteValue[];
};
export type PublicSeoSeoUrlListResponse = {
  /** The rewrite rules, grouped by the frontend route they target. */
  routes: PublicSeoSeoUrlListResponseRoute[];
  /** Redirects to apply before looking for a rewrite. */
  redirects: PublicSeoSeoUrlListResponseRedirect[];
  /** Custom SEO URLs, each served from its own internal target. */
  rewrites: PublicSeoSeoUrlListResponseRewrite[];
};
export type PublicSeoResolveRedirectResponse = {
  /** False when the path does not redirect anywhere. */
  found: boolean;
  /** The target path or absolute URL, null when nothing matched. */
  target?: string | null;
  /** True for a permanent (301) redirect. */
  permanent: boolean;
};
export type PublicStatisticsCreateRequest = {
  /** The entry type. */
  type: string;
  /** An optional identifier. */
  id?: string | null;
  /** Additional custom data. */
  additionalData?: string | null;
  /** An optional session ID. When omitted, internal ASP.NET session ID is used. */
  sessionId?: string | null;
  /** A timestamp when the entry was created.
    If this is specified and the difference between the current time and the timestamp
    is bigger than a configured time span (10s per default), the entry is discarded. */
  timestamp: string;
};
export const {
  useGetV1AccountByIdQuery,
  usePostV1AccountAccountMutation,
  useGetV1AccountAccountQuery,
  useGetV1AccountAccountByIdQuery,
  usePutV1AccountAccountByIdMutation,
  useGetV1AccountAccountLoginInfoQuery,
  useGetV1AccountAccountLoginSettingsQuery,
  usePutV1AccountAccountLoginSettingsMutation,
  usePostV1AccountAddressMutation,
  useGetV1AccountAddressQuery,
  useDeleteV1AccountAddressByIdMutation,
  usePutV1AccountAddressByIdMutation,
  usePostV1AccountApiKeysMutation,
  useGetV1AccountApiKeysQuery,
  usePutV1AccountApiKeysByUidRevokeMutation,
  useGetV1AccountApiLogsImportExecutionsByIdQuery,
  useGetV1AccountApiLogsImportExecutionsQuery,
  useGetV1AccountAttributeQuery,
  useGetV1AccountCategoryQuery,
  useGetV1AccountCategoryByIdQuery,
  useGetV1AccountConfigurationDataObjectTypesQuery,
  useGetV1AccountConfigurationProcessQuery,
  useGetV1AccountContactMessagesAttachmentsByFileIdQuery,
  useGetV1AccountContactMessagesByIdQuery,
  useGetV1AccountContactMessagesCountsQuery,
  useGetV1AccountContactMessagesQuery,
  usePutV1AccountContactMessagesReadMutation,
  usePutV1AccountContactMessagesByIdUnreadMutation,
  usePostV1AccountContactMessagesByIdReplyMutation,
  usePostV1AccountContactPersonMutation,
  useGetV1AccountContactPersonQuery,
  useDeleteV1AccountContactPersonByIdMutation,
  usePutV1AccountContactPersonByIdMutation,
  usePostV1AccountContractsCreateMutation,
  useGetV1AccountContractsQuery,
  usePostV1AccountContractsUpgradeMutation,
  usePutV1AccountDataObjectByIdActivateMutation,
  usePostV1AccountDataObjectMutation,
  useGetV1AccountDataObjectQuery,
  usePutV1AccountDataObjectByIdDeactivateMutation,
  useDeleteV1AccountDataObjectByIdMutation,
  useGetV1AccountDataObjectByIdQuery,
  usePutV1AccountDataObjectByIdMutation,
  usePostV1AccountDataObjectByIdDuplicateMutation,
  useGetV1AccountDataObjectCountsQuery,
  usePutV1AccountDataObjectByIdTopListingMutation,
  usePostV1AccountLoginMigrationValidateMutation,
  usePutV1AccountLoginsAcceptInvitationMutation,
  usePostV1AccountLoginsMutation,
  useGetV1AccountLoginsQuery,
  useGetV1AccountLoginsInvitationsQuery,
  usePutV1AccountLoginsRejectInvitationMutation,
  useDeleteV1AccountLoginsByIdMutation,
  usePutV1AccountLoginsSetRoleMutation,
  useDeleteV1AccountLogoMutation,
  usePostV1AccountLogoMutation,
  useGetV1AccountLogoByAccountIdQuery,
  usePostV1AccountPaymentsCreateMutation,
  useGetV1AccountPaymentsContractQuery,
  useGetV1AccountPaymentsOrderQuery,
  useGetV1AccountPaymentsStatusQuery,
  usePostV1AccountPaymentsPrintOrderMutation,
  usePostV1AccountPaymentsCallbackByProviderNameTransactionMutation,
  useGetV1AccountPaymentsTokenQuery,
  usePostV1AccountPrintAdvertAcceptQuoteMutation,
  useGetV1AccountPrintAdvertIssueDatesQuery,
  useGetV1AccountPrintAdvertQuoteQuery,
  useGetV1AccountPrintAdvertByIdQuery,
  usePostV1AccountPrintAdvertPreviewMutation,
  usePostV1AccountPrintAdvertPublishMutation,
  useGetV1AccountProductsQuery,
  useGetV1AccountPublicationPriceQuery,
  useGetV1AccountPublicationOptionsQuery,
  useGetV1AccountPublicationDataObjectByIdQuery,
  usePostV1AccountPublicationDataObjectByIdMutation,
  useGetV1AttributeQuery,
  useGetV1AttributeEntriesQuery,
  useGetV1AutocompleteQuery,
  useGetV1CategoryQuery,
  useGetV1ConfigurationPlatformsQuery,
  useGetV1DataObjectCountQuery,
  useGetV1DataObjectByIdQuery,
  useGetV1DataObjectQuery,
  usePostV1DataObjectByIdContactMutation,
  usePostV1DataObjectByIdReportMutation,
  useGetV1FavoriteQuery,
  useDeleteV1FavoriteMutation,
  usePostV1FavoriteMutation,
  useGetV1FileAdvertListPdfByAccountIdQuery,
  useGetV1FileByIdQuery,
  useGetV1FileTemporaryByIdQuery,
  useGetV1GeoLocationsQuery,
  useGetV1GeoRegionsQuery,
  useGetV1PrintTitleNextIssueInfoQuery,
  usePutV1SearchAlertsByIdActivateMutation,
  usePostV1SearchAlertsMutation,
  useGetV1SearchAlertsQuery,
  useDeleteV1SearchAlertsByIdMutation,
  useGetV1SearchAlertsByIdQuery,
  usePutV1SearchAlertsByIdMutation,
  usePutV1SearchAlertsByIdInteractionMutation,
  useGetV1SeoPageContentQuery,
  useGetV1SeoUrlsQuery,
  useGetV1SeoRedirectQuery,
  usePostV1StatisticsMutation,
  useGetV1StatisticsImageQuery,
  useGetServiceImportServiceAsmxQuery,
  useGetServiceImportServiceAsmxIcwQuery,
  usePostServiceImportServiceAsmxIcwMutation,
  useGetServiceImportServiceAsmxIrwQuery,
  usePostServiceImportServiceAsmxIrwMutation,
  useGetServiceImportServiceAsmxVerifyQuery,
  usePostServiceImportServiceAsmxVerifyMutation,
  useGetServiceImportServiceAsmxCheckProcessQuery,
  usePostServiceImportServiceAsmxCheckProcessMutation,
  useGetServiceImportServiceAsmxClearFolderQuery,
  usePostServiceImportServiceAsmxClearFolderMutation,
} = injectedRtkApi;
